import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint react/jsx-no-bind: 0 */
import React, { useState } from "react";
import ReactDOM from "react-dom";
import { arrayMove } from "react-sortable-hoc";
import copy from "copy-to-clipboard";
import { invert, isNumber, toNumber, isEmpty, min, max, flatMap, set, map, toString, camelCase, startCase, noop, isEqual, cloneDeep, keyBy, omit, forEach, lowerCase, get, padStart, omitBy, times } from "lodash";
import joinUrl from "url-join";
import { Button, Menu, MenuItem, Classes, ContextMenu, Checkbox, Icon, Popover, Intent, Callout, Tooltip } from "@blueprintjs/core";
import classNames from "classnames";
import scrollIntoView from "dom-scroll-into-view";
import { SortableElement } from "react-sortable-hoc";
import ReactTable from "@teselagen/react-table";
import { withProps, branch, compose } from "recompose";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import ReactMarkdown from "react-markdown";
import immer, { produceWithPatches, enablePatches, applyPatches } from "immer";
import papaparse from "papaparse";
import TgSelect from "../TgSelect";
import { withHotkeys } from "../utils/hotkeyUtils";
import InfoHelper from "../InfoHelper";
import getTextFromEl from "../utils/getTextFromEl";
import { getSelectedRowsFromEntities } from "./utils/selection";
import rowClick, { changeSelectedEntities, finalizeSelection } from "./utils/rowClick";
import PagingTool from "./PagingTool";
import FilterAndSortMenu from "./FilterAndSortMenu";
import getIdOrCodeOrIndex from "./utils/getIdOrCodeOrIndex";
import SearchBar from "./SearchBar";
import DisplayOptions from "./DisplayOptions";
import DisabledLoadingComponent from "./DisabledLoadingComponent";
import SortableColumns from "./SortableColumns";
import computePresets from "./utils/computePresets";
import dataTableEnhancer from "./dataTableEnhancer";
import defaultProps from "./defaultProps";
import "../toastr";
import "@teselagen/react-table/react-table.css";
import "./style.css";
import { getRecordsFromIdMap } from "./utils/withSelectedEntities";
import { CellDragHandle } from "./CellDragHandle";
import { nanoid } from "nanoid";
enablePatches();
var PRIMARY_SELECTED_VAL = "main_cell";
dayjs.extend(localizedFormat);
var IS_LINUX = window.navigator.platform.toLowerCase().search("linux") > -1;

var DataTable = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DataTable, _React$Component);

  function DataTable(_props) {
    var _this;

    _this = _React$Component.call(this, _props) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      columns: [],
      fullscreen: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggleFullscreen", function () {
      _this.setState({
        fullscreen: !_this.state.fullscreen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnterStartCellEdit", function (e) {
      e.stopPropagation();

      _this.startCellEdit(_this.getPrimarySelectedCellId());
    });

    _defineProperty(_assertThisInitialized(_this), "flashTableBorder", function () {
      try {
        var table = ReactDOM.findDOMNode(_this.table);
        table.classList.add("tgBorderBlue");
        setTimeout(function () {
          table.classList.remove("tgBorderBlue");
        }, 300);
      } catch (e) {
        console.error("err when flashing table border:", e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleUndo", function () {
      var _this$props = _this.props,
          change = _this$props.change,
          entities = _this$props.entities,
          _this$props$reduxForm = _this$props.reduxFormEntitiesUndoRedoStack,
          reduxFormEntitiesUndoRedoStack = _this$props$reduxForm === void 0 ? {
        currentVersion: 0
      } : _this$props$reduxForm;

      if (reduxFormEntitiesUndoRedoStack.currentVersion > 0) {
        _this.flashTableBorder();

        var nextState = applyPatches(entities, reduxFormEntitiesUndoRedoStack[reduxFormEntitiesUndoRedoStack.currentVersion].inversePatches);

        var _this$formatAndValida = _this.formatAndValidateEntities(nextState),
            newEnts = _this$formatAndValida.newEnts,
            validationErrors = _this$formatAndValida.validationErrors;

        change("reduxFormEntities", newEnts);
        change("reduxFormCellValidation", validationErrors);
        change("reduxFormEntitiesUndoRedoStack", _extends({}, reduxFormEntitiesUndoRedoStack, {
          currentVersion: reduxFormEntitiesUndoRedoStack.currentVersion - 1
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleRedo", function () {
      var _this$props2 = _this.props,
          change = _this$props2.change,
          entities = _this$props2.entities,
          _this$props2$reduxFor = _this$props2.reduxFormEntitiesUndoRedoStack,
          reduxFormEntitiesUndoRedoStack = _this$props2$reduxFor === void 0 ? {
        currentVersion: 0
      } : _this$props2$reduxFor;
      var nextV = reduxFormEntitiesUndoRedoStack.currentVersion + 1;

      if (reduxFormEntitiesUndoRedoStack[nextV]) {
        _this.flashTableBorder();

        var nextState = applyPatches(entities, reduxFormEntitiesUndoRedoStack[nextV].patches);

        var _this$formatAndValida2 = _this.formatAndValidateEntities(nextState),
            newEnts = _this$formatAndValida2.newEnts,
            validationErrors = _this$formatAndValida2.validationErrors;

        change("reduxFormEntities", newEnts);
        change("reduxFormCellValidation", validationErrors);
        change("reduxFormEntitiesUndoRedoStack", _extends({}, reduxFormEntitiesUndoRedoStack, {
          currentVersion: nextV
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateFromProps", function (oldProps, newProps) {
      var selectedIds = newProps.selectedIds,
          _newProps$entities = newProps.entities,
          entities = _newProps$entities === void 0 ? [] : _newProps$entities,
          isEntityDisabled = newProps.isEntityDisabled,
          expandAllByDefault = newProps.expandAllByDefault,
          selectAllByDefault = newProps.selectAllByDefault,
          reduxFormSelectedEntityIdMap = newProps.reduxFormSelectedEntityIdMap,
          reduxFormExpandedEntityIdMap = newProps.reduxFormExpandedEntityIdMap,
          change = newProps.change;
      var table = ReactDOM.findDOMNode(_this.table);
      var idMap = reduxFormSelectedEntityIdMap; //handle programatic filter adding

      if (!isEqual(newProps.additionalFilters, oldProps.additionalFilters)) {
        newProps.addFilters(newProps.additionalFilters);
      }

      if (!isEqual(newProps.schema, oldProps.schema)) {
        var _newProps$schema = newProps.schema,
            schema = _newProps$schema === void 0 ? {} : _newProps$schema;
        var columns = schema.fields ? schema.fields.reduce(function (columns, field, i) {
          if (field.isHidden) {
            return columns;
          }

          return columns.concat(_extends({}, field, {
            columnIndex: i
          }));
        }, []) : [];

        _this.setState({
          columns: columns
        });
      }

      var selectedIdsToUse = selectedIds;
      var newIdMap; //handle selecting all or expanding all

      if ((selectAllByDefault || expandAllByDefault) && !isEqual((newProps.entities || []).map(function (_ref) {
        var id = _ref.id;
        return id;
      }), oldProps.entities && oldProps.entities.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      }))) {
        if (selectAllByDefault && !_this.alreadySelected && entities && entities.length) {
          _this.alreadySelected = true;
          newIdMap = _extends({}, (entities || []).reduce(function (acc, entity) {
            acc[entity.id || entity.code] = {
              entity: entity,
              time: Date.now()
            };
            return acc;
          }, {}), reduxFormSelectedEntityIdMap || {});
          selectedIdsToUse = map(newIdMap, function (a, key) {
            return key;
          });
        }

        if (expandAllByDefault) {
          change("reduxFormExpandedEntityIdMap", _extends({}, (entities || []).reduce(function (acc, e) {
            acc[e.id || e.code] = true;
            return acc;
          }, {}), reduxFormExpandedEntityIdMap || {}));
        }
      } // handle programmatic selection and scrolling


      var oldSelectedIds = oldProps.selectedIds;

      if (isEqual(selectedIdsToUse, oldSelectedIds)) {
        // if not changing selectedIds then we just want to make sure selected entities
        // stored in redux are in proper format
        // if selected ids have changed then it will handle redux selection
        var tableScrollElement = table.getElementsByClassName("rt-table")[0];
        var _oldProps$entities = oldProps.entities,
            oldEntities = _oldProps$entities === void 0 ? [] : _oldProps$entities,
            oldIdMap = oldProps.reduxFormSelectedEntityIdMap;
        var reloaded = oldProps.isLoading && !_this.props.isLoading;
        var entitiesHaveChanged = oldEntities.length !== entities.length || getIdOrCodeOrIndex(entities[0] || {}) !== getIdOrCodeOrIndex(oldEntities[0] || {}); // if switching pages or searching the table we want to reset the scrollbar

        if (tableScrollElement.scrollTop > 0 && !_this.props.isCellEditable) {
          if (reloaded || entitiesHaveChanged) {
            tableScrollElement.scrollTop = 0;
          }
        } // re-index entities in redux form so that sorting will be correct in withSelectedEntities


        if (change) {
          if (entitiesHaveChanged && (!isEmpty(oldIdMap) || !isEmpty(idMap))) {
            changeSelectedEntities({
              idMap: idMap,
              entities: entities,
              change: change
            });
          } else if (!isEmpty(idMap) && idMap[Object.keys(idMap)[0]] && idMap[Object.keys(idMap)[0]].rowIndex === undefined) {
            // if programmatically selected will still want the order to match the table sorting.
            changeSelectedEntities({
              idMap: idMap,
              entities: entities,
              change: change
            });
          }
        }
      } else {
        var idArray = Array.isArray(selectedIdsToUse) ? selectedIdsToUse : [selectedIdsToUse];
        var selectedEntities = entities.filter(function (e) {
          return idArray.indexOf(getIdOrCodeOrIndex(e)) > -1 && !isEntityDisabled(e);
        });
        newIdMap = newIdMap || selectedEntities.reduce(function (acc, entity) {
          acc[getIdOrCodeOrIndex(entity)] = {
            entity: entity
          };
          return acc;
        }, {});
        change("reduxFormExpandedEntityIdMap", newIdMap);
        finalizeSelection({
          idMap: newIdMap,
          entities: entities,
          props: newProps
        });
        var idToScrollTo = idArray[0];
        if (!idToScrollTo && idToScrollTo !== 0) return;
        var entityIndexToScrollTo = entities.findIndex(function (e) {
          return e.id === idToScrollTo || e.code === idToScrollTo;
        });
        if (entityIndexToScrollTo === -1 || !table) return;
        var tableBody = table.querySelector(".rt-tbody");
        if (!tableBody) return;
        var rowEl = tableBody.getElementsByClassName("rt-tr-group")[entityIndexToScrollTo];
        if (!rowEl) return;
        setTimeout(function () {
          //we need to delay for a teeny bit to make sure the table has drawn
          rowEl && tableBody && scrollIntoView(rowEl, tableBody, {
            alignWithTop: true
          });
        }, 0);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "formatAndValidateEntities", function (entities) {
      var schema = _this.props.schema;
      var editableFields = schema.fields.filter(function (f) {
        return !f.isNotEditable;
      });
      var validationErrors = {};
      var newEnts = immer(entities, function (entities) {
        entities.forEach(function (e, index) {
          editableFields.forEach(function (columnSchema) {
            //mutative
            var _editCellHelper = editCellHelper({
              entity: e,
              columnSchema: columnSchema,
              newVal: e[columnSchema.path]
            }),
                error = _editCellHelper.error;

            if (error) {
              var rowId = getIdOrCodeOrIndex(e, index);
              validationErrors[rowId + ":" + columnSchema.path] = error;
            }
          });
        });
      });
      return {
        newEnts: newEnts,
        validationErrors: validationErrors
      };
    });

    _defineProperty(_assertThisInitialized(_this), "formatAndValidateTableInitial", function () {
      var _this$props3 = _this.props,
          entities = _this$props3._origEntities,
          initialEntities = _this$props3.initialEntities,
          change = _this$props3.change;

      var _this$formatAndValida3 = _this.formatAndValidateEntities(initialEntities || entities),
          newEnts = _this$formatAndValida3.newEnts,
          validationErrors = _this$formatAndValida3.validationErrors;

      change("reduxFormEntities", newEnts);
      change("reduxFormCellValidation", validationErrors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowMove", function (type, shiftHeld) {
      return function (e) {
        e.preventDefault();
        e.stopPropagation();
        var props = computePresets(_this.props);
        var noSelect = props.noSelect,
            entities = props.entities,
            idMap = props.reduxFormSelectedEntityIdMap,
            isEntityDisabled = props.isEntityDisabled,
            isSingleSelect = props.isSingleSelect;
        var newIdMap = {};
        var lastSelectedEnt = getLastSelectedEntity(idMap);
        if (noSelect) return;

        if (lastSelectedEnt) {
          var lastSelectedIndex = entities.findIndex(function (ent) {
            return ent === lastSelectedEnt;
          });

          if (lastSelectedIndex === -1) {
            if (lastSelectedEnt.id !== undefined) {
              lastSelectedIndex = entities.findIndex(function (ent) {
                return ent.id === lastSelectedEnt.id;
              });
            } else if (lastSelectedEnt.code !== undefined) {
              lastSelectedIndex = entities.findIndex(function (ent) {
                return ent.code === lastSelectedEnt.code;
              });
            }
          }

          if (lastSelectedIndex === -1) {
            return;
          }

          var newEntToSelect = getNewEntToSelect({
            type: type,
            lastSelectedIndex: lastSelectedIndex,
            entities: entities,
            isEntityDisabled: isEntityDisabled
          });
          if (!newEntToSelect) return;

          if (shiftHeld && !isSingleSelect) {
            if (idMap[newEntToSelect.id || newEntToSelect.code]) {
              //the entity being moved to has already been selected
              newIdMap = omit(idMap, [lastSelectedEnt.id || lastSelectedEnt.code]);
              newIdMap[newEntToSelect.id || newEntToSelect.code].time = Date.now() + 1;
            } else {
              var _extends2;

              //the entity being moved to has NOT been selected yet
              newIdMap = _extends({}, idMap, (_extends2 = {}, _extends2[newEntToSelect.id || newEntToSelect.code] = {
                entity: newEntToSelect,
                time: Date.now()
              }, _extends2));
            }
          } else {
            //no shiftHeld
            newIdMap[newEntToSelect.id || newEntToSelect.code] = {
              entity: newEntToSelect,
              time: Date.now()
            };
          }
        }

        finalizeSelection({
          idMap: newIdMap,
          entities: entities,
          props: props
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleCopyHotkey", function (e) {
      var _computePresets = computePresets(_this.props),
          isCellEditable = _computePresets.isCellEditable,
          reduxFormSelectedEntityIdMap = _computePresets.reduxFormSelectedEntityIdMap;

      if (isCellEditable) {
        _this.handleCopySelectedCells(e);
      } else {
        _this.handleCopySelectedRows(getRecordsFromIdMap(reduxFormSelectedEntityIdMap), e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getPrimarySelectedCellId", function () {
      var _this$props$reduxForm2 = _this.props.reduxFormSelectedCells,
          reduxFormSelectedCells = _this$props$reduxForm2 === void 0 ? {} : _this$props$reduxForm2;

      for (var _i = 0, _Object$keys = Object.keys(reduxFormSelectedCells); _i < _Object$keys.length; _i++) {
        var k = _Object$keys[_i];

        if (reduxFormSelectedCells[k] === PRIMARY_SELECTED_VAL) {
          return k;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePaste", function (e) {
      var _computePresets2 = computePresets(_this.props),
          isCellEditable = _computePresets2.isCellEditable,
          reduxFormSelectedCells = _computePresets2.reduxFormSelectedCells,
          reduxFormCellValidation = _computePresets2.reduxFormCellValidation,
          change = _computePresets2.change,
          schema = _computePresets2.schema,
          entities = _computePresets2.entities;

      if (isCellEditable) {
        if (isEmpty(reduxFormSelectedCells)) return;

        try {
          var pasteData = [];
          var toPaste;

          if (window.clipboardData && window.clipboardData.getData) {
            // IE
            toPaste = window.clipboardData.getData("Text");
          } else if (e.clipboardData && e.clipboardData.getData) {
            toPaste = e.clipboardData.getData("text/plain");
          }

          if (toPaste.includes(",")) {
            //try papaparsing it out as a csv if it contains commas
            try {
              var _papaparse$parse = papaparse.parse(toPaste, {
                header: false
              }),
                  data = _papaparse$parse.data,
                  errors = _papaparse$parse.errors;

              if (data != null && data.length && !(errors != null && errors.length)) {
                pasteData = data;
              }
            } catch (error) {
              console.error("error p982qhgpf9qh", error);
            }
          }

          pasteData = pasteData.length ? pasteData : defaultParsePaste(toPaste);
          if (!pasteData || !pasteData.length) return;

          if (pasteData.length === 1 && pasteData[0].length === 1) {
            var newCellValidate = _extends({}, reduxFormCellValidation); // single paste value, fill all cells with value


            var newVal = pasteData[0][0];

            _this.updateEntitiesHelper(entities, function (entities) {
              var entityIdToEntity = getEntityIdToEntity(entities);
              Object.keys(reduxFormSelectedCells).forEach(function (cellId) {
                var _cellId$split = cellId.split(":"),
                    rowId = _cellId$split[0],
                    path = _cellId$split[1];

                var entity = entityIdToEntity[rowId].e;

                var _editCellHelper2 = editCellHelper({
                  entity: entity,
                  path: path,
                  schema: schema,
                  newVal: newVal
                }),
                    error = _editCellHelper2.error;

                if (error) {
                  newCellValidate[cellId] = error;
                } else {
                  delete newCellValidate[cellId];
                }
              });
            });

            change("reduxFormCellValidation", newCellValidate);
          } else {
            // handle paste in same format
            var primarySelectedCell = _this.getPrimarySelectedCellId();

            if (primarySelectedCell) {
              var _newCellValidate = _extends({}, reduxFormCellValidation);

              var newSelectedCells = _extends({}, reduxFormSelectedCells);

              _this.updateEntitiesHelper(entities, function (entities) {
                var entityIdToEntity = getEntityIdToEntity(entities);

                var _primarySelectedCell$ = primarySelectedCell.split(":"),
                    rowId = _primarySelectedCell$[0],
                    primaryCellPath = _primarySelectedCell$[1];

                var primaryEntityInfo = entityIdToEntity[rowId];
                var startIndex = primaryEntityInfo.i;
                var endIndex = primaryEntityInfo.i + pasteData.length;

                for (var i = startIndex; i < endIndex; i++) {
                  if (!entities[i]) {
                    entities[i] = {
                      id: nanoid()
                    };
                  }
                }

                var entitiesToManipulate = entities.slice(startIndex, endIndex);
                var pathToIndex = getFieldPathToIndex(schema);
                var indexToPath = invert(pathToIndex);
                var startCellIndex = pathToIndex[primaryCellPath];
                pasteData.forEach(function (row, i) {
                  row.forEach(function (cell, j) {
                    if (cell) {
                      var cellIndexToChange = startCellIndex + j;
                      var entity = entitiesToManipulate[i];

                      if (entity) {
                        var path = indexToPath[cellIndexToChange];

                        if (path) {
                          var _editCellHelper3 = editCellHelper({
                            entity: entity,
                            path: path,
                            schema: schema,
                            newVal: cell
                          }),
                              error = _editCellHelper3.error;

                          var cellId = getIdOrCodeOrIndex(entity) + ":" + path;

                          if (!newSelectedCells[cellId]) {
                            newSelectedCells[cellId] = true;
                          }

                          if (error) {
                            _newCellValidate[cellId] = error;
                          } else {
                            delete _newCellValidate[cellId];
                          }
                        }
                      }
                    }
                  });
                });
              });

              change("reduxFormCellValidation", _newCellValidate);
              change("reduxFormSelectedCells", newSelectedCells);
            }
          }
        } catch (error) {
          console.error("error:", error);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectAllRows", function (e) {
      var _computePresets3 = computePresets(_this.props),
          change = _computePresets3.change,
          isEntityDisabled = _computePresets3.isEntityDisabled,
          entities = _computePresets3.entities,
          isSingleSelect = _computePresets3.isSingleSelect,
          isCellEditable = _computePresets3.isCellEditable,
          schema = _computePresets3.schema;

      if (isSingleSelect) return;
      e.preventDefault();

      if (isCellEditable) {
        var schemaPaths = schema.fields.map(function (f) {
          return f.path;
        });
        var newSelectedCells = {};
        entities.forEach(function (entity, i) {
          if (isEntityDisabled(entity)) return;
          var entityId = getIdOrCodeOrIndex(entity, i);
          schemaPaths.forEach(function (p) {
            newSelectedCells[entityId + ":" + p] = true;
          });
        });
        change("reduxFormSelectedCells", newSelectedCells);
      } else {
        var newIdMap = {};
        entities.forEach(function (entity, i) {
          if (isEntityDisabled(entity)) return;
          var entityId = getIdOrCodeOrIndex(entity, i);
          newIdMap[entityId] = {
            entity: entity
          };
        });
        finalizeSelection({
          idMap: newIdMap,
          entities: entities,
          props: computePresets(_this.props)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDeleteCell", function () {
      var _computePresets4 = computePresets(_this.props),
          reduxFormSelectedCells = _computePresets4.reduxFormSelectedCells,
          reduxFormCellValidation = _computePresets4.reduxFormCellValidation,
          change = _computePresets4.change,
          schema = _computePresets4.schema,
          entities = _computePresets4.entities;

      var newCellValidate = _extends({}, reduxFormCellValidation);

      if (isEmpty(reduxFormSelectedCells)) return;

      _this.updateEntitiesHelper(entities, function (entities) {
        var entityIdToEntity = getEntityIdToEntity(entities);
        Object.keys(reduxFormSelectedCells).forEach(function (cellId) {
          var _cellId$split2 = cellId.split(":"),
              rowId = _cellId$split2[0],
              path = _cellId$split2[1];

          var entity = entityIdToEntity[rowId].e;

          var _editCellHelper4 = editCellHelper({
            entity: entity,
            path: path,
            schema: schema,
            newVal: ""
          }),
              error = _editCellHelper4.error;

          if (error) {
            newCellValidate[cellId] = error;
          } else {
            delete newCellValidate[cellId];
          }
        });
      });

      change("reduxFormCellValidation", newCellValidate);
    });

    _defineProperty(_assertThisInitialized(_this), "handleCut", function (e) {
      _this.handleDeleteCell();

      _this.handleCopyHotkey(e);
    });

    _defineProperty(_assertThisInitialized(_this), "getCellCopyText", function (cellWrapper) {
      var text = cellWrapper && cellWrapper.getAttribute("data-copy-text");
      var toRet = text || cellWrapper.textContent || "";
      return toRet;
    });

    _defineProperty(_assertThisInitialized(_this), "handleCopyRow", function (rowEl) {
      //takes in a row element
      var text = _this.getRowCopyText(rowEl);

      if (!text) return window.toastr.warning("No text to copy");

      _this.handleCopyHelper(text, "Row Copied");
    });

    _defineProperty(_assertThisInitialized(_this), "handleCopyColumn", function (e, cellWrapper) {
      var cellType = cellWrapper.getAttribute("data-test");
      var allRowEls = getAllRows(e);
      if (!allRowEls) return;
      var textToCopy = map(allRowEls, function (rowEl) {
        return _this.getRowCopyText(rowEl, {
          cellType: cellType
        });
      }).filter(function (text) {
        return text;
      }).join("\n");
      if (!textToCopy) return window.toastr.warning("No text to copy");

      _this.handleCopyHelper(textToCopy, "Column copied");
    });

    _defineProperty(_assertThisInitialized(_this), "updateEntitiesHelper", function (ents, fn) {
      var _extends3;

      var _this$props4 = _this.props,
          change = _this$props4.change,
          _this$props4$reduxFor = _this$props4.reduxFormEntitiesUndoRedoStack,
          reduxFormEntitiesUndoRedoStack = _this$props4$reduxFor === void 0 ? {
        currentVersion: 0
      } : _this$props4$reduxFor;

      var _produceWithPatches = produceWithPatches(ents, fn),
          nextState = _produceWithPatches[0],
          patches = _produceWithPatches[1],
          inversePatches = _produceWithPatches[2];

      if (!inversePatches.length) return;
      var thatNewNew = [].concat(nextState);
      thatNewNew.isDirty = true;
      change("reduxFormEntities", thatNewNew);
      change("reduxFormEntitiesUndoRedoStack", _extends({}, omitBy(reduxFormEntitiesUndoRedoStack, function (v, k) {
        return toNumber(k) > reduxFormEntitiesUndoRedoStack.currentVersion + 1;
      }), (_extends3 = {
        currentVersion: reduxFormEntitiesUndoRedoStack.currentVersion + 1
      }, _extends3[reduxFormEntitiesUndoRedoStack.currentVersion + 1] = {
        inversePatches: inversePatches,
        patches: patches
      }, _extends3)));
    });

    _defineProperty(_assertThisInitialized(_this), "getRowCopyText", function (rowEl, _temp) {
      var _ref3 = _temp === void 0 ? {} : _temp,
          cellType = _ref3.cellType;

      //takes in a row element
      if (!rowEl) return;
      return flatMap(rowEl.children, function (cellEl) {
        var cellChild = cellEl.querySelector("[data-copy-text]");

        if (!cellChild) {
          if (cellType) return []; //strip it

          return; //just leave it blank
        }

        if (cellType && cellChild.getAttribute("data-test") !== cellType) {
          return [];
        }

        return _this.getCellCopyText(cellChild);
      }).join("\t");
    });

    _defineProperty(_assertThisInitialized(_this), "handleCopyHelper", function (stringToCopy, message) {
      var copyHandler = function copyHandler(e) {
        e.preventDefault();
        e.clipboardData.setData("text/plain", stringToCopy);
      };

      document.addEventListener("copy", copyHandler);
      !window.Cypress && copy(stringToCopy, {
        // keep this so that pasting into spreadsheets works.
        format: "text/plain"
      });
      document.removeEventListener("copy", copyHandler);
      window.toastr.success(message);
    });

    _defineProperty(_assertThisInitialized(_this), "handleCopyTable", function (e) {
      try {
        var allRowEls = getAllRows(e);
        if (!allRowEls) return; //get row elements and call this.handleCopyRow for each

        var textToCopy = map(allRowEls, function (rowEl) {
          return _this.getRowCopyText(rowEl);
        }).filter(function (text) {
          return text;
        }).join("\n");
        if (!textToCopy) return window.toastr.warning("No text to copy");

        _this.handleCopyHelper(textToCopy, "Table copied");
      } catch (error) {
        console.error("error:", error);
        window.toastr.error("Error copying rows.");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCopySelectedCells", function (e) {
      var _computePresets5 = computePresets(_this.props),
          _computePresets5$enti = _computePresets5.entities,
          entities = _computePresets5$enti === void 0 ? [] : _computePresets5$enti,
          reduxFormSelectedCells = _computePresets5.reduxFormSelectedCells,
          schema = _computePresets5.schema; // if the current selection is consecutive cells then copy with
      // tabs between. if not then just select primary selected cell


      if (isEmpty(reduxFormSelectedCells)) return;
      var pathToIndex = getFieldPathToIndex(schema);
      var entityIdToEntity = getEntityIdToEntity(entities);
      var selectionGrid = [];
      var firstRowIndex;
      var firstCellIndex;
      Object.keys(reduxFormSelectedCells).forEach(function (key) {
        var _key$split = key.split(":"),
            rowId = _key$split[0],
            path = _key$split[1];

        var eInfo = entityIdToEntity[rowId];

        if (eInfo) {
          if (firstRowIndex === undefined || eInfo.i < firstRowIndex) {
            firstRowIndex = eInfo.i;
          }

          if (!selectionGrid[eInfo.i]) {
            selectionGrid[eInfo.i] = [];
          }

          var cellIndex = pathToIndex[path];

          if (firstCellIndex === undefined || cellIndex < firstCellIndex) {
            firstCellIndex = cellIndex;
          }

          selectionGrid[eInfo.i][cellIndex] = true;
        }
      });
      if (firstRowIndex === undefined) return;
      var allRows = getAllRows(e);
      var fullCellText = "";
      times(selectionGrid.length, function (i) {
        var row = selectionGrid[i];

        if (fullCellText) {
          fullCellText += "\n";
        }

        if (!row) {
          return;
        } else {
          // ignore header
          var rowCopyText = _this.getRowCopyText(allRows[i + 1]).split("\t");

          times(row.length, function (i) {
            var cell = row[i];

            if (cell) {
              fullCellText += rowCopyText[i];
            }

            if (i !== row.length - 1 && i >= firstCellIndex) fullCellText += "\t";
          });
        }
      });
      if (!fullCellText) return window.toastr.warning("No text to copy");

      _this.handleCopyHelper(fullCellText, "Selected cells copied");
    });

    _defineProperty(_assertThisInitialized(_this), "handleCopySelectedRows", function (selectedRecords, e) {
      var _computePresets6 = computePresets(_this.props),
          _computePresets6$enti = _computePresets6.entities,
          entities = _computePresets6$enti === void 0 ? [] : _computePresets6$enti;

      var idToIndex = entities.reduce(function (acc, e, i) {
        acc[e.id || e.code] = i;
        return acc;
      }, {}); //index 0 of the table is the column titles
      //must add 1 to rowNum

      var rowNumbersToCopy = selectedRecords.map(function (rec) {
        return idToIndex[rec.id || rec.code] + 1;
      }).sort();
      if (!rowNumbersToCopy.length) return;
      rowNumbersToCopy.unshift(0); //add in the header row

      try {
        var allRowEls = getAllRows(e);
        if (!allRowEls) return;
        var rowEls = rowNumbersToCopy.map(function (i) {
          return allRowEls[i];
        }); //get row elements and call this.handleCopyRow for each const rowEls = this.getRowEls(rowNumbersToCopy)

        var textToCopy = map(rowEls, function (rowEl) {
          return _this.getRowCopyText(rowEl);
        }).filter(function (text) {
          return text;
        }).join("\n");
        if (!textToCopy) return window.toastr.warning("No text to copy");

        _this.handleCopyHelper(textToCopy, "Selected rows copied");
      } catch (error) {
        console.error("error:", error);
        window.toastr.error("Error copying rows.");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "moveColumn", function (_ref4) {
      var oldIndex = _ref4.oldIndex,
          newIndex = _ref4.newIndex;
      var columns = _this.state.columns;
      var oldStateColumnIndex, newStateColumnIndex;
      columns.forEach(function (column, i) {
        if (oldIndex === column.columnIndex) oldStateColumnIndex = i;
        if (newIndex === column.columnIndex) newStateColumnIndex = i;
      }); // because it is all handled in state we need
      // to perform the move and update the columnIndices
      // because they are used for the sortable columns

      var newColumns = arrayMove(columns, oldStateColumnIndex, newStateColumnIndex).map(function (column, i) {
        return _extends({}, column, {
          columnIndex: i
        });
      });

      _this.setState({
        columns: newColumns
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getTheadComponent", function (props) {
      var _computePresets7 = computePresets(_this.props),
          withDisplayOptions = _computePresets7.withDisplayOptions,
          moveColumnPersist = _computePresets7.moveColumnPersist,
          syncDisplayOptionsToDb = _computePresets7.syncDisplayOptionsToDb,
          change = _computePresets7.change;

      var moveColumnPersistToUse = moveColumnPersist;

      if (moveColumnPersist && withDisplayOptions && !syncDisplayOptionsToDb) {
        //little hack to make localstorage changes get reflected in UI (we force an update to get the enhancers to run again :)
        moveColumnPersistToUse = function moveColumnPersistToUse() {
          moveColumnPersist.apply(void 0, arguments);
          change("localStorageForceUpdate", Math.random());
        };
      }

      return /*#__PURE__*/React.createElement(SortableColumns, _extends({}, props, {
        withDisplayOptions: withDisplayOptions,
        moveColumn: moveColumnPersistToUse || _this.moveColumn
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "getThComponent", compose(withProps(function (props) {
      var columnindex = props.columnindex;
      return {
        index: columnindex || 0
      };
    }), branch(function (_ref5) {
      var immovable = _ref5.immovable;
      return "true" !== immovable;
    }, SortableElement))(function (_ref6) {
      var toggleSort = _ref6.toggleSort,
          className = _ref6.className,
          children = _ref6.children,
          rest = _objectWithoutPropertiesLoose(_ref6, ["toggleSort", "className", "children"]);

      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames("rt-th", className),
        onClick: function onClick(e) {
          return toggleSort && toggleSort(e);
        },
        role: "columnheader",
        tabIndex: "-1" // Resolves eslint issues without implementing keyboard navigation incorrectly

      }, rest), children);
    }));

    _defineProperty(_assertThisInitialized(_this), "addEntitiesToSelection", function (entities) {
      var propPresets = computePresets(_this.props);
      var isEntityDisabled = propPresets.isEntityDisabled,
          reduxFormSelectedEntityIdMap = propPresets.reduxFormSelectedEntityIdMap;
      var idMap = reduxFormSelectedEntityIdMap || {};
      var newIdMap = cloneDeep(idMap) || {};
      entities.forEach(function (entity, i) {
        if (isEntityDisabled(entity)) return;
        var entityId = getIdOrCodeOrIndex(entity, i);
        newIdMap[entityId] = {
          entity: entity
        };
      });
      finalizeSelection({
        idMap: newIdMap,
        entities: entities,
        props: propPresets
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getTableRowProps", function (state, rowInfo) {
      var _computePresets8 = computePresets(_this.props),
          reduxFormSelectedEntityIdMap = _computePresets8.reduxFormSelectedEntityIdMap,
          reduxFormExpandedEntityIdMap = _computePresets8.reduxFormExpandedEntityIdMap,
          withCheckboxes = _computePresets8.withCheckboxes,
          _onDoubleClick = _computePresets8.onDoubleClick,
          history = _computePresets8.history,
          mustClickCheckboxToSelect = _computePresets8.mustClickCheckboxToSelect,
          entities = _computePresets8.entities,
          isEntityDisabled = _computePresets8.isEntityDisabled,
          change = _computePresets8.change,
          getRowClassName = _computePresets8.getRowClassName,
          isCellEditable = _computePresets8.isCellEditable;

      if (!rowInfo) {
        return {
          className: "no-row-data"
        };
      }

      var entity = rowInfo.original;
      var rowId = getIdOrCodeOrIndex(entity, rowInfo.index);
      var rowSelected = reduxFormSelectedEntityIdMap[rowId];
      var isExpanded = reduxFormExpandedEntityIdMap[rowId];
      var rowDisabled = isEntityDisabled(entity);
      var dataId = entity.id || entity.code;
      return {
        onClick: function onClick(e) {
          if (isCellEditable) return; // if checkboxes are activated or row expander is clicked don't select row

          if (e.target.matches(".tg-expander, .tg-expander *")) {
            var _extends4;

            change("reduxFormExpandedEntityIdMap", _extends({}, reduxFormExpandedEntityIdMap, (_extends4 = {}, _extends4[rowId] = !isExpanded, _extends4)));
            return;
          } else if (e.target.closest(".tg-react-table-checkbox-cell-container")) {
            return;
          } else if (mustClickCheckboxToSelect) {
            return;
          }

          if (e.detail > 1) {
            return; //cancel multiple quick clicks
          }

          rowClick(e, rowInfo, entities, computePresets(_this.props));
        },
        //row right click
        onContextMenu: function onContextMenu(e) {
          e.preventDefault();
          if (rowId === undefined || rowDisabled || isCellEditable) return;
          var oldIdMap = cloneDeep(reduxFormSelectedEntityIdMap) || {};
          var newIdMap;

          if (withCheckboxes) {
            newIdMap = oldIdMap;
          } else {
            var _ref7;

            // if we are not using checkboxes we need to make sure
            // that the id of the record gets added to the id map
            newIdMap = oldIdMap[rowId] ? oldIdMap : (_ref7 = {}, _ref7[rowId] = {
              entity: entity
            }, _ref7); // tgreen: this will refresh the selection with fresh data. The entities in redux might not be up to date

            var keyedEntities = keyBy(entities, getIdOrCodeOrIndex);
            forEach(newIdMap, function (val, key) {
              var freshEntity = keyedEntities[key];

              if (freshEntity) {
                newIdMap[key] = _extends({}, newIdMap[key], {
                  entity: freshEntity
                });
              }
            });
            finalizeSelection({
              idMap: newIdMap,
              entities: entities,
              props: computePresets(_this.props)
            });
          }

          _this.showContextMenu(e, newIdMap);
        },
        className: classNames("with-row-data", getRowClassName && getRowClassName(rowInfo, state, _this.props), {
          disabled: rowDisabled,
          selected: rowSelected && !withCheckboxes
        }),
        "data-test-id": dataId === undefined ? rowInfo.index : dataId,
        "data-index": rowInfo.index,
        onDoubleClick: function onDoubleClick(e) {
          if (rowDisabled) return;
          _this.dblClickTriggered = true;
          _onDoubleClick && _onDoubleClick(rowInfo.original, rowInfo.index, history, e);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "startCellEdit", function (cellId) {
      var _computePresets9 = computePresets(_this.props),
          change = _computePresets9.change,
          _computePresets9$redu = _computePresets9.reduxFormSelectedCells,
          reduxFormSelectedCells = _computePresets9$redu === void 0 ? {} : _computePresets9$redu;

      var newSelectedCells = _extends({}, reduxFormSelectedCells);

      newSelectedCells[cellId] = PRIMARY_SELECTED_VAL;
      change("reduxFormSelectedCells", newSelectedCells);
      change("reduxFormEditingCell", cellId);
    });

    _defineProperty(_assertThisInitialized(_this), "getTableCellProps", function (state, rowInfo, column) {
      var _schema$fields, _schema$fields2;

      var _computePresets10 = computePresets(_this.props),
          entities = _computePresets10.entities,
          schema = _computePresets10.schema,
          reduxFormEditingCell = _computePresets10.reduxFormEditingCell,
          isCellEditable = _computePresets10.isCellEditable,
          reduxFormCellValidation = _computePresets10.reduxFormCellValidation,
          _computePresets10$red = _computePresets10.reduxFormSelectedCells,
          reduxFormSelectedCells = _computePresets10$red === void 0 ? {} : _computePresets10$red,
          isEntityDisabled = _computePresets10.isEntityDisabled,
          change = _computePresets10.change;

      if (!isCellEditable) return {}; //only allow cell selection to do stuff here

      if (!rowInfo) return {};
      var entity = rowInfo.original;
      var rowIndex = rowInfo.index;
      var rowId = getIdOrCodeOrIndex(entity, rowIndex);
      var columnIndex = column.columnIndex;
      var cellIdToLeft = rowId + ":" + ((_schema$fields = schema.fields[columnIndex - 1]) == null ? void 0 : _schema$fields.path);
      var cellIdToRight = rowId + ":" + ((_schema$fields2 = schema.fields[columnIndex + 1]) == null ? void 0 : _schema$fields2.path);
      var rowAboveId = entities[rowInfo.index - 1] && getIdOrCodeOrIndex(entities[rowInfo.index - 1], rowInfo.index - 1);
      var rowBelowId = entities[rowInfo.index + 1] && getIdOrCodeOrIndex(entities[rowInfo.index + 1], rowInfo.index + 1);
      var cellIdAbove = rowAboveId + ":" + column.path;
      var cellIdBelow = rowBelowId + ":" + column.path;
      var cellId = rowId + ":" + column.path;
      var rowDisabled = isEntityDisabled(entity);
      var err = reduxFormCellValidation[cellId];
      var selectedTopBorder, selectedRightBorder, selectedBottomBorder, selectedLeftBorder;

      if (reduxFormSelectedCells[cellId]) {
        selectedTopBorder = !reduxFormSelectedCells[cellIdAbove];
        selectedRightBorder = !reduxFormSelectedCells[cellIdToRight];
        selectedBottomBorder = !reduxFormSelectedCells[cellIdBelow];
        selectedLeftBorder = !reduxFormSelectedCells[cellIdToLeft];
      }

      var isPrimarySelected = reduxFormSelectedCells[cellId] === PRIMARY_SELECTED_VAL;
      var className = classNames({
        isSelectedCell: reduxFormSelectedCells[cellId],
        isPrimarySelected: isPrimarySelected,
        isSecondarySelected: reduxFormSelectedCells[cellId] === true,
        noSelectedTopBorder: !selectedTopBorder,
        noSelectedRightBorder: !selectedRightBorder,
        noSelectedBottomBorder: !selectedBottomBorder,
        noSelectedLeftBorder: !selectedLeftBorder,
        isDropdownCell: column.type === "dropdown",
        isEditingCell: reduxFormEditingCell === cellId,
        hasCellError: !!err,
        "no-data-tip": reduxFormSelectedCells[cellId]
      });
      return _extends({
        onDoubleClick: function onDoubleClick() {
          // cell double click
          if (rowDisabled) return;

          _this.startCellEdit(cellId);
        }
      }, err && {
        "data-tip": err
      }, {
        onContextMenu: function onContextMenu(e) {
          if (!isPrimarySelected) {
            var primaryCellId = _this.getPrimarySelectedCellId();

            var newSelectedCells = _extends({}, reduxFormSelectedCells);

            if (primaryCellId) {
              newSelectedCells[primaryCellId] = true;
            }

            newSelectedCells[cellId] = PRIMARY_SELECTED_VAL;
            change("reduxFormSelectedCells", newSelectedCells);
          }

          setTimeout(function () {
            //need a timeout so reduxFormSelectedCells is up to date in the context menu
            _this.showContextMenu(e);
          }, 0);
        },
        onClick: function onClick(e) {
          // cell click, cellclick
          var _computePresets11 = computePresets(_this.props),
              change = _computePresets11.change,
              reduxFormEditingCell = _computePresets11.reduxFormEditingCell,
              _computePresets11$red = _computePresets11.reduxFormSelectedCells,
              reduxFormSelectedCells = _computePresets11$red === void 0 ? {} : _computePresets11$red;

          var shift = e.shiftKey;
          var meta = e.metaKey;
          if (rowDisabled) return;

          var newSelectedCells = _extends({}, reduxFormSelectedCells);

          if (newSelectedCells[cellId] && !shift) {
            // don't deselect if editing
            if (reduxFormEditingCell === cellId) return;

            if (meta) {
              delete newSelectedCells[cellId];
            } else {
              newSelectedCells = {};
            }
          } else {
            var primarySelectedCellId = _this.getPrimarySelectedCellId();

            if (meta) {
              if (isEmpty(newSelectedCells)) {
                newSelectedCells[cellId] = PRIMARY_SELECTED_VAL;
              } else {
                newSelectedCells[cellId] = PRIMARY_SELECTED_VAL;
                if (primarySelectedCellId) newSelectedCells[primarySelectedCellId] = true;
              }
            } else if (shift) {
              if (primarySelectedCellId) {
                var _primarySelectedCellI = primarySelectedCellId.split(":"),
                    _rowId = _primarySelectedCellI[0],
                    colPath = _primarySelectedCellI[1];

                var primaryRowIndex = entities.findIndex(function (e, i) {
                  return getIdOrCodeOrIndex(e, i) === _rowId;
                });
                var fieldToIndex = getFieldPathToIndex(schema);
                var primaryColIndex = fieldToIndex[colPath];

                if (primaryRowIndex === -1 || primaryColIndex === -1) {
                  newSelectedCells = {};
                  newSelectedCells[cellId] = PRIMARY_SELECTED_VAL;
                } else {
                  var _newSelectedCells;

                  var minRowIndex = min([primaryRowIndex, rowIndex]);
                  var minColIndex = min([primaryColIndex, columnIndex]);
                  var maxRowIndex = max([primaryRowIndex, rowIndex]);
                  var maxColIndex = max([primaryColIndex, columnIndex]);
                  var entitiesBetweenRows = entities.slice(minRowIndex, maxRowIndex + 1);
                  var fieldsBetweenCols = schema.fields.slice(minColIndex, maxColIndex + 1);
                  newSelectedCells = (_newSelectedCells = {}, _newSelectedCells[primarySelectedCellId] = PRIMARY_SELECTED_VAL, _newSelectedCells);
                  entitiesBetweenRows.forEach(function (e) {
                    var rowId = getIdOrCodeOrIndex(e, entities.indexOf(e));
                    fieldsBetweenCols.forEach(function (f) {
                      var cellId = rowId + ":" + f.path;
                      if (!newSelectedCells[cellId]) newSelectedCells[cellId] = true;
                    });
                  });
                  newSelectedCells[cellId] = PRIMARY_SELECTED_VAL;
                  newSelectedCells[primarySelectedCellId] = true;
                }
              } else {
                newSelectedCells = {};
                newSelectedCells[cellId] = PRIMARY_SELECTED_VAL;
              }
            } else {
              newSelectedCells = {};
              newSelectedCells[cellId] = PRIMARY_SELECTED_VAL;
            }
          }

          change("reduxFormSelectedCells", newSelectedCells);
        },
        className: className
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCheckboxHeader", function () {
      var _computePresets12 = computePresets(_this.props),
          reduxFormSelectedEntityIdMap = _computePresets12.reduxFormSelectedEntityIdMap,
          isSingleSelect = _computePresets12.isSingleSelect,
          noSelect = _computePresets12.noSelect,
          noUserSelect = _computePresets12.noUserSelect,
          entities = _computePresets12.entities,
          isEntityDisabled = _computePresets12.isEntityDisabled;

      var checkedRows = getSelectedRowsFromEntities(entities, reduxFormSelectedEntityIdMap);
      var checkboxProps = {
        checked: false,
        indeterminate: false
      };
      var notDisabledEntityCount = entities.reduce(function (acc, e) {
        return isEntityDisabled(e) ? acc : acc + 1;
      }, 0);

      if (checkedRows.length === notDisabledEntityCount) {
        //tnr: maybe this will need to change if we want enable select all across pages
        checkboxProps.checked = notDisabledEntityCount !== 0;
      } else {
        if (checkedRows.length) {
          checkboxProps.indeterminate = true;
        }
      }

      return !isSingleSelect ? /*#__PURE__*/React.createElement(Checkbox, _extends({
        disabled: noSelect || noUserSelect
        /* eslint-disable react/jsx-no-bind */
        ,
        onChange: function onChange() {
          var newIdMap = cloneDeep(reduxFormSelectedEntityIdMap) || {};
          entities.forEach(function (entity, i) {
            if (isEntityDisabled(entity)) return;
            var entityId = getIdOrCodeOrIndex(entity, i);

            if (checkboxProps.checked) {
              delete newIdMap[entityId];
            } else {
              newIdMap[entityId] = {
                entity: entity
              };
            }
          });
          finalizeSelection({
            idMap: newIdMap,
            entities: entities,
            props: computePresets(_this.props)
          });
        }
        /* eslint-enable react/jsx-no-bind */

      }, checkboxProps)) : null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderCheckboxCell", function (row) {
      var rowIndex = row.index;

      var _computePresets13 = computePresets(_this.props),
          reduxFormSelectedEntityIdMap = _computePresets13.reduxFormSelectedEntityIdMap,
          noSelect = _computePresets13.noSelect,
          noUserSelect = _computePresets13.noUserSelect,
          entities = _computePresets13.entities,
          isEntityDisabled = _computePresets13.isEntityDisabled;

      var checkedRows = getSelectedRowsFromEntities(entities, reduxFormSelectedEntityIdMap);
      var isSelected = checkedRows.some(function (rowNum) {
        return rowNum === rowIndex;
      });

      if (rowIndex >= entities.length) {
        return /*#__PURE__*/React.createElement("div", null);
      }

      var entity = entities[rowIndex];
      return /*#__PURE__*/React.createElement(Checkbox, {
        disabled: noSelect || noUserSelect || isEntityDisabled(entity),
        onClick: function onClick(e) {
          rowClick(e, row, entities, computePresets(_this.props));
        },
        checked: isSelected
      });
    });

    _defineProperty(_assertThisInitialized(_this), "finishCellEdit", function (cellId, newVal) {
      var _computePresets14 = computePresets(_this.props),
          _computePresets14$ent = _computePresets14.entities,
          entities = _computePresets14$ent === void 0 ? [] : _computePresets14$ent,
          change = _computePresets14.change,
          schema = _computePresets14.schema,
          reduxFormCellValidation = _computePresets14.reduxFormCellValidation;

      var _cellId$split3 = cellId.split(":"),
          rowId = _cellId$split3[0],
          path = _cellId$split3[1];

      change("reduxFormEditingCell", null);

      _this.updateEntitiesHelper(entities, function (entities) {
        var _extends5;

        var entity = entities.find(function (e, i) {
          return getIdOrCodeOrIndex(e, i) === rowId;
        });

        var _editCellHelper5 = editCellHelper({
          entity: entity,
          path: path,
          schema: schema,
          newVal: newVal
        }),
            error = _editCellHelper5.error;

        change("reduxFormCellValidation", _extends({}, reduxFormCellValidation, (_extends5 = {}, _extends5[cellId] = error, _extends5)));
      });

      _this.refocusTable();
    });

    _defineProperty(_assertThisInitialized(_this), "cancelCellEdit", function () {
      var _computePresets15 = computePresets(_this.props),
          change = _computePresets15.change;

      change("reduxFormEditingCell", null);

      _this.refocusTable();
    });

    _defineProperty(_assertThisInitialized(_this), "refocusTable", function () {
      setTimeout(function () {
        var table = ReactDOM.findDOMNode(_this.table).closest(".data-table-container");
        table.focus();
      }, 0);
    });

    _defineProperty(_assertThisInitialized(_this), "isSelectionARectangleWithPrimaryInCorner", function () {
      var _computePresets16 = computePresets(_this.props),
          entities = _computePresets16.entities,
          reduxFormSelectedCells = _computePresets16.reduxFormSelectedCells,
          schema = _computePresets16.schema;

      if (Object.keys(reduxFormSelectedCells).length > 1) {
        var pathToIndex = getFieldPathToIndex(schema);
        var entityMap = getEntityIdToEntity(entities);
        var primaryCellId;
        var selectionGrid = [];
        var firstCellIndex;
        var lastCellIndex;
        var lastRowIndex;
        var firstRowIndex;
        var selectedPaths = [];
        Object.keys(reduxFormSelectedCells).forEach(function (key) {
          if (reduxFormSelectedCells[key] === PRIMARY_SELECTED_VAL) {
            primaryCellId = key;
          }

          var _key$split2 = key.split(":"),
              rowId = _key$split2[0],
              cellPath = _key$split2[1];

          if (!selectedPaths.includes(cellPath)) selectedPaths.push(cellPath);
          var cellIndex = pathToIndex[cellPath];
          var i = entityMap[rowId].i;

          if (firstRowIndex === undefined || i < firstRowIndex) {
            firstRowIndex = i;
          }

          if (lastRowIndex === undefined || i > lastRowIndex) {
            lastRowIndex = i;
          }

          if (!selectionGrid[i]) selectionGrid[i] = [];
          selectionGrid[i][cellIndex] = {
            cellId: key,
            rowIndex: i,
            cellIndex: cellIndex
          };

          if (firstCellIndex === undefined || cellIndex < firstCellIndex) {
            firstCellIndex = cellIndex;
          }

          if (lastCellIndex === undefined || cellIndex > lastCellIndex) {
            lastCellIndex = cellIndex;
          }
        });
        selectionGrid = selectionGrid.slice(firstRowIndex);
        var isRectangle = true;

        for (var i = 0; i < selectionGrid.length; i++) {
          var row = selectionGrid[i];

          if (!row) {
            isRectangle = false;
            break;
          } else {
            for (var j = firstCellIndex; j < row.length; j++) {
              if (!row[j]) {
                isRectangle = false;
                break;
              }
            }
          }
        }

        if (isRectangle) {
          selectionGrid.forEach(function (row) {
            // remove undefineds from start of row
            while (row[0] === undefined && row.length) {
              row.shift();
            }
          }); // primary cell must be in a corner for this to happen

          var _primaryCellId$split = primaryCellId.split(":"),
              rowId = _primaryCellId$split[0],
              cellPath = _primaryCellId$split[1];

          var _i2 = entityMap[rowId].i;
          var cellIndex = pathToIndex[cellPath];
          var isTopLeft = _i2 === firstRowIndex && cellIndex === firstCellIndex;
          var isTopRight = _i2 === firstRowIndex && cellIndex === lastCellIndex;
          var isBottomLeft = _i2 === lastRowIndex && cellIndex === firstCellIndex;
          var isBottomRight = _i2 === lastRowIndex && cellIndex === lastCellIndex;

          if (isTopLeft || isTopRight || isBottomLeft || isBottomRight) {
            return {
              selectedPaths: selectedPaths,
              selectionGrid: selectionGrid
            };
          }
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "renderColumns", function () {
      var _computePresets17 = computePresets(_this.props),
          isCellEditable = _computePresets17.isCellEditable,
          cellRenderer = _computePresets17.cellRenderer,
          withCheckboxes = _computePresets17.withCheckboxes,
          SubComponent = _computePresets17.SubComponent,
          shouldShowSubComponent = _computePresets17.shouldShowSubComponent,
          entities = _computePresets17.entities,
          isEntityDisabled = _computePresets17.isEntityDisabled,
          getCellHoverText = _computePresets17.getCellHoverText,
          withExpandAndCollapseAllButton = _computePresets17.withExpandAndCollapseAllButton,
          reduxFormExpandedEntityIdMap = _computePresets17.reduxFormExpandedEntityIdMap,
          change = _computePresets17.change,
          reduxFormSelectedCells = _computePresets17.reduxFormSelectedCells,
          reduxFormEditingCell = _computePresets17.reduxFormEditingCell;

      var columns = _this.state.columns;

      if (!columns.length) {
        return columns;
      }

      var columnsToRender = [];

      if (SubComponent) {
        columnsToRender.push(_extends({}, withExpandAndCollapseAllButton && {
          Header: function Header() {
            var showCollapseAll = Object.values(reduxFormExpandedEntityIdMap).filter(function (i) {
              return i;
            }).length === entities.length;
            return /*#__PURE__*/React.createElement(InfoHelper, {
              content: showCollapseAll ? "Collapse All" : "Expand All",
              isButton: true,
              minimal: true,
              small: true,
              style: {
                padding: 2
              },
              popoverProps: {
                modifiers: {
                  preventOverflow: {
                    enabled: false
                  },
                  hide: {
                    enabled: false
                  }
                }
              },
              onClick: function onClick() {
                showCollapseAll ? change("reduxFormExpandedEntityIdMap", {}) : change("reduxFormExpandedEntityIdMap", entities.reduce(function (acc, e) {
                  acc[e.id] = true;
                  return acc;
                }, {}));
              },
              className: classNames("tg-expander-all"),
              icon: showCollapseAll ? "chevron-down" : "chevron-right"
            });
          }
        }, {
          expander: true,
          Expander: function Expander(_ref8) {
            var isExpanded = _ref8.isExpanded,
                record = _ref8.original;
            var shouldShow = true;

            if (shouldShowSubComponent) {
              shouldShow = shouldShowSubComponent(record);
            }

            if (!shouldShow) return null;
            return /*#__PURE__*/React.createElement(Button, {
              className: classNames("tg-expander", Classes.MINIMAL, Classes.SMALL),
              icon: isExpanded ? "chevron-down" : "chevron-right"
            });
          }
        }));
      }

      if (withCheckboxes) {
        columnsToRender.push({
          Header: _this.renderCheckboxHeader,
          Cell: _this.renderCheckboxCell,
          width: 35,
          resizable: false,
          getHeaderProps: function getHeaderProps() {
            return {
              className: "tg-react-table-checkbox-header-container",
              immovable: "true"
            };
          },
          getProps: function getProps() {
            return {
              className: "tg-react-table-checkbox-cell-container"
            };
          }
        });
      }

      columns.forEach(function (column) {
        var tableColumn = _extends({}, column, {
          Header: _this.renderColumnHeader(column),
          accessor: column.path,
          getHeaderProps: function getHeaderProps() {
            return {
              // needs to be a string because it is getting passed
              // to the dom
              immovable: column.immovable ? "true" : "false",
              columnindex: column.columnIndex
            };
          }
        });

        var noEllipsis = column.noEllipsis;

        if (column.width) {
          tableColumn.width = column.width;
        }

        if (cellRenderer && cellRenderer[column.path]) {
          tableColumn.Cell = function (row) {
            var val = cellRenderer[column.path](row.value, row.original, row, _this.props);
            return val;
          };
        } else if (column.render) {
          tableColumn.Cell = function (row) {
            var val = column.render(row.value, row.original, row, _this.props);
            return val;
          };
        } else if (column.type === "timestamp") {
          tableColumn.Cell = function (props) {
            return props.value ? dayjs(props.value).format("lll") : "";
          };
        } else if (column.type === "color") {
          tableColumn.Cell = function (props) {
            return props.value ? /*#__PURE__*/React.createElement("div", {
              style: {
                height: 20,
                width: 40,
                background: props.value,
                border: "1px solid #182026",
                borderRadius: 5
              }
            }) : "";
          };
        } else if (column.type === "boolean") {
          if (isCellEditable) {
            tableColumn.Cell = function (props) {
              return props.value ? "True" : "False";
            };
          } else {
            tableColumn.Cell = function (props) {
              var _classNames;

              return /*#__PURE__*/React.createElement(Icon, {
                className: classNames((_classNames = {}, _classNames[Classes.TEXT_MUTED] = !props.value, _classNames)),
                icon: props.value ? "tick" : "cross"
              });
            };
          }
        } else if (column.type === "markdown") {
          tableColumn.Cell = function (props) {
            return /*#__PURE__*/React.createElement(ReactMarkdown, null, props.value);
          };
        } else {
          tableColumn.Cell = function (props) {
            return props.value;
          };
        }

        var oldFunc = tableColumn.Cell;

        tableColumn.Cell = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var row = args[0];
          var rowId = getIdOrCodeOrIndex(row.original, row.index);
          var cellId = rowId + ":" + row.column.path;
          var val = oldFunc.apply(void 0, args);
          var oldVal = val;

          var text = _this.getCopyTextForCell(val, row, column);

          var isBool = column.type === "boolean";

          if (isCellEditable && isBool) {
            val = /*#__PURE__*/React.createElement(Checkbox, {
              disabled: isEntityDisabled(row.original),
              className: "tg-cell-edit-boolean-checkbox",
              checked: oldVal === "True",
              onChange: function onChange(e) {
                var checked = e.target.checked;

                _this.finishCellEdit(cellId, checked);
              }
            });
            noEllipsis = true;
          } else {
            if (reduxFormEditingCell === cellId) {
              if (column.type === "dropdown") {
                return /*#__PURE__*/React.createElement(DropdownCell, {
                  initialValue: text,
                  options: column.values,
                  finishEdit: function finishEdit(newVal) {
                    _this.finishCellEdit(cellId, newVal);
                  },
                  cancelEdit: _this.cancelCellEdit
                });
              } else {
                return /*#__PURE__*/React.createElement(EditableCell, {
                  cancelEdit: _this.cancelCellEdit,
                  isNumeric: column.type === "numeric",
                  initialValue: text,
                  finishEdit: function finishEdit(newVal) {
                    _this.finishCellEdit(cellId, newVal);
                  }
                });
              }
            }
          } //wrap the original tableColumn.Cell function in another div in order to add a title attribute


          var title = text;
          if (getCellHoverText) title = getCellHoverText.apply(void 0, args);else if (column.getTitleAttr) title = column.getTitleAttr.apply(column, args);
          var isSelectedCell = reduxFormSelectedCells == null ? void 0 : reduxFormSelectedCells[cellId]; // if (isSelectedCell) {
          //   const [rowId2, path] = cellId.split(":");
          //   const selectedEnt = entities.find((e, i) => {
          //     return getIdOrCodeOrIndex(e, i) === rowId2;
          //   });
          // }

          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            style: _extends({}, !noEllipsis && {
              textOverflow: "ellipsis",
              overflow: "hidden"
            }),
            "data-test": "tgCell_" + column.path,
            className: "tg-cell-wrapper",
            "data-copy-text": text,
            title: title || undefined
          }, val), isCellEditable && column.type === "dropdown" && /*#__PURE__*/React.createElement(Icon, {
            icon: "caret-down",
            style: {
              position: "absolute",
              right: 5,
              opacity: 0.3
            },
            className: "cell-edit-dropdown",
            onClick: function onClick() {
              _this.startCellEdit(cellId);
            }
          }), isSelectedCell && isSelectedCell === PRIMARY_SELECTED_VAL && /*#__PURE__*/React.createElement(CellDragHandle, {
            key: cellId,
            thisTable: _this.table,
            cellId: cellId,
            isSelectionARectangleWithPrimaryInCorner: _this.isSelectionARectangleWithPrimaryInCorner,
            onDragEnd: _this.onDragEnd
          }));
        };

        columnsToRender.push(tableColumn);
      });
      return columnsToRender;
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnd", function (cellsToSelect) {
      var _this$props5 = _this.props,
          entities = _this$props5.entities,
          schema = _this$props5.schema,
          reduxFormCellValidation = _this$props5.reduxFormCellValidation,
          change = _this$props5.change,
          reduxFormSelectedCells = _this$props5.reduxFormSelectedCells;

      var primaryCellId = _this.getPrimarySelectedCellId();

      var _primaryCellId$split2 = primaryCellId.split(":"),
          primaryRowId = _primaryCellId$split2[0],
          primaryCellPath = _primaryCellId$split2[1];

      var pathToField = getFieldPathToField(schema);

      var _ref9 = _this.isSelectionARectangleWithPrimaryInCorner() || {},
          selectedPaths = _ref9.selectedPaths,
          selectionGrid = _ref9.selectionGrid;

      var allSelectedPaths = selectedPaths;

      if (!allSelectedPaths) {
        allSelectedPaths = [primaryCellPath];
      }

      _this.updateEntitiesHelper(entities, function (entities) {
        var newReduxFormSelectedCells;

        if (selectedPaths) {
          newReduxFormSelectedCells = _extends({}, reduxFormSelectedCells);
        } else {
          var _newReduxFormSelected;

          newReduxFormSelectedCells = (_newReduxFormSelected = {}, _newReduxFormSelected[primaryCellId] = PRIMARY_SELECTED_VAL, _newReduxFormSelected);
        }

        var newCellValidate = _extends({}, reduxFormCellValidation);

        var entityMap = getEntityIdToEntity(entities);
        var _entityMap$primaryRow = entityMap[primaryRowId],
            selectedEnt = _entityMap$primaryRow.e,
            primaryRowIndex = _entityMap$primaryRow.i;
        var newPrimaryRowIndex = primaryRowIndex;
        var newPrimaryCellId;
        allSelectedPaths.forEach(function (selectedPath) {
          var column = pathToField[selectedPath];
          var selectedCellVal = getCellVal(selectedEnt, selectedPath, column);
          var incrementStart;
          var incrementPrefix;
          var incrementPad = 0;

          if (column.type === "string" || column.type === "number") {
            var cellNumStr = getNumberStrAtEnd(selectedCellVal);
            var cellNum = Number(cellNumStr);
            var entityAbovePrimaryCell = entities[entityMap[primaryRowId].i - 1];

            if (entityAbovePrimaryCell && !isNaN(cellNum)) {
              var cellAboveVal = get(entityAbovePrimaryCell, selectedPath, "");
              var cellAboveNumStr = getNumberStrAtEnd(cellAboveVal);
              var cellAboveNum = Number(cellAboveNumStr);

              if (!isNaN(cellAboveNum)) {
                var isIncremental = cellNum - cellAboveNum === 1;

                if (isIncremental) {
                  var cellTextNoNum = stripNumberAtEnd(selectedCellVal);
                  var sameText = stripNumberAtEnd(cellAboveVal) === cellTextNoNum;

                  if (sameText) {
                    incrementStart = cellNum + 1;
                    incrementPrefix = cellTextNoNum || "";

                    if (cellNumStr.startsWith("0")) {
                      incrementPad = cellNumStr.length;
                    }
                  }
                }
              }
            }
          }

          var pathToIndex = getFieldPathToIndex(schema);
          cellsToSelect.forEach(function (cellId) {
            var _cellId$split4 = cellId.split(":"),
                rowId = _cellId$split4[0],
                cellPath = _cellId$split4[1];

            if (cellPath !== selectedPath) return;
            newReduxFormSelectedCells[cellId] = true;

            var _ref10 = entityMap[rowId] || {},
                entityToUpdate = _ref10.e,
                rowIndex = _ref10.i;

            if (entityToUpdate) {
              // if this is the entity at the new bottom/top of the drag in the primary column it should now
              // be primary. This ensures primary is always at the corner of the rectangle
              var isNewBottom = rowIndex > primaryRowIndex && rowIndex > newPrimaryRowIndex;
              var isNewTop = rowIndex < primaryRowIndex && rowIndex < newPrimaryRowIndex;

              if (cellPath === primaryCellPath && (isNewBottom || isNewTop)) {
                newPrimaryRowIndex = rowIndex;
                newPrimaryCellId = cellId;
              }

              var newVal;

              if (incrementStart !== undefined) {
                var num = incrementStart++;
                newVal = incrementPrefix + padStart(num, incrementPad, "0");
              } else {
                if (selectionGrid && selectionGrid.length > 1) {
                  // if there are multiple cells selected then we want to copy them repeating
                  // ex: if we have 1,2,3 selected and we drag for 5 more rows we want it to
                  // be 1,2,3,1,2 for the new row cells in this column
                  var draggingDown = rowIndex > selectionGrid[0][0].rowIndex;
                  var cellIndex = pathToIndex[cellPath];
                  var cellIdToCopy;

                  if (draggingDown) {
                    var firstIndexInGrid = selectionGrid[0][0].rowIndex;

                    var _selectionGrid$find = selectionGrid[(rowIndex - firstIndexInGrid) % selectionGrid.length].find(function (g) {
                      return g.cellIndex === cellIndex;
                    }),
                        _cellId = _selectionGrid$find.cellId;

                    cellIdToCopy = _cellId;
                  } else {
                    var lastIndexInGrid = selectionGrid[selectionGrid.length - 1][0].rowIndex;

                    var _selectionGrid$find2 = selectionGrid[(rowIndex + lastIndexInGrid + 1) % selectionGrid.length].find(function (g) {
                      return g.cellIndex === cellIndex;
                    }),
                        _cellId2 = _selectionGrid$find2.cellId;

                    cellIdToCopy = _cellId2;
                  }

                  var _cellIdToCopy$split = cellIdToCopy.split(":"),
                      rowIdToCopy = _cellIdToCopy$split[0],
                      cellPathToCopy = _cellIdToCopy$split[1];

                  newVal = getCellVal(entityMap[rowIdToCopy].e, cellPathToCopy, pathToField[cellPathToCopy]);
                } else {
                  newVal = selectedCellVal;
                }
              }

              var _editCellHelper6 = editCellHelper({
                entity: entityToUpdate,
                path: cellPath,
                schema: schema,
                newVal: newVal
              }),
                  error = _editCellHelper6.error;

              newCellValidate[cellId] = error;
            }
          });
        }); // select the new cells

        change("reduxFormCellValidation", newCellValidate);

        if (newPrimaryCellId) {
          newReduxFormSelectedCells[primaryCellId] = true;
          newReduxFormSelectedCells[newPrimaryCellId] = PRIMARY_SELECTED_VAL;
        }

        change("reduxFormSelectedCells", newReduxFormSelectedCells);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getCopyTextForCell", function (val, row, column) {
      var _computePresets18 = computePresets(_this.props),
          cellRenderer = _computePresets18.cellRenderer; // TODOCOPY we need a way to potentially omit certain columns from being added as a \t element (talk to taoh about this)


      var text = typeof val !== "string" ? row.value : val;
      var record = row.original;

      if (column.getClipboardData) {
        text = column.getClipboardData(row.value, record, row, _this.props);
      } else if (column.getValueToFilterOn) {
        text = column.getValueToFilterOn(record, _this.props);
      } else if (column.render) {
        text = column.render(row.value, record, row, _this.props);
      } else if (cellRenderer && cellRenderer[column.path]) {
        text = cellRenderer[column.path](row.value, row.original, row, _this.props);
      } else if (text) {
        text = String(text);
      }

      var getTextFromElementOrLink = function getTextFromElementOrLink(text) {
        if (React.isValidElement(text)) {
          var _text$props;

          if ((_text$props = text.props) != null && _text$props.to) {
            var _window$frontEndConfi;

            // this will convert Link elements to url strings
            return joinUrl(window.location.origin, ((_window$frontEndConfi = window.frontEndConfig) == null ? void 0 : _window$frontEndConfi.clientBasePath) || "", text.props.to);
          } else {
            return getTextFromEl(text);
          }
        } else {
          return text;
        }
      };

      text = getTextFromElementOrLink(text);

      if (Array.isArray(text)) {
        var arrText = text.map(getTextFromElementOrLink).join(", "); // because we sometimes insert commas after links when mapping over an array of elements we will have double ,'s

        arrText = arrText.replace(/, ,/g, ",");
        text = arrText;
      }

      var stringText = toString(text);
      if (stringText === "[object Object]") return "";
      return stringText;
    });

    _defineProperty(_assertThisInitialized(_this), "insertRows", function (_temp2) {
      var _ref11 = _temp2 === void 0 ? {} : _temp2,
          above = _ref11.above,
          _ref11$numRows = _ref11.numRows,
          numRows = _ref11$numRows === void 0 ? 1 : _ref11$numRows,
          appendToBottom = _ref11.appendToBottom;

      var _computePresets19 = computePresets(_this.props),
          _computePresets19$ent = _computePresets19.entities,
          entities = _computePresets19$ent === void 0 ? [] : _computePresets19$ent,
          reduxFormCellValidation = _computePresets19.reduxFormCellValidation,
          change = _computePresets19.change;

      var primaryCellId = _this.getPrimarySelectedCellId();

      var _ref12 = (primaryCellId == null ? void 0 : primaryCellId.split(":")) || [],
          rowId = _ref12[0];

      _this.updateEntitiesHelper(entities, function (entities) {
        var newEntities = times(numRows).map(function () {
          return {
            id: nanoid()
          };
        });
        var indexToInsert = entities.findIndex(function (e, i) {
          return getIdOrCodeOrIndex(e, i) === rowId;
        });
        var insertIndex = above ? indexToInsert : indexToInsert + 1;

        var _this$formatAndValida4 = _this.formatAndValidateEntities(newEntities),
            newEnts = _this$formatAndValida4.newEnts,
            validationErrors = _this$formatAndValida4.validationErrors;

        change("reduxFormCellValidation", _extends({}, reduxFormCellValidation, validationErrors));
        entities.splice.apply(entities, [appendToBottom ? entities.length : insertIndex, 0].concat(newEnts));
      });

      _this.refocusTable();
    });

    _defineProperty(_assertThisInitialized(_this), "showContextMenu", function (e, idMap) {
      var _computePresets20 = computePresets(_this.props),
          history = _computePresets20.history,
          contextMenu = _computePresets20.contextMenu,
          isCopyable = _computePresets20.isCopyable,
          isCellEditable = _computePresets20.isCellEditable,
          _computePresets20$ent = _computePresets20.entities,
          entities = _computePresets20$ent === void 0 ? [] : _computePresets20$ent,
          _computePresets20$red = _computePresets20.reduxFormSelectedCells,
          reduxFormSelectedCells = _computePresets20$red === void 0 ? {} : _computePresets20$red;

      var selectedRecords;

      if (isCellEditable) {
        var rowIds = {};
        Object.keys(reduxFormSelectedCells).forEach(function (cellKey) {
          var _cellKey$split = cellKey.split(":"),
              rowId = _cellKey$split[0];

          rowIds[rowId] = true;
        });
        selectedRecords = entities.filter(function (e) {
          return rowIds[getIdOrCodeOrIndex(e)];
        });
      } else {
        selectedRecords = getRecordsFromIdMap(idMap);
      }

      var itemsToRender = contextMenu({
        selectedRecords: selectedRecords,
        history: history
      });
      if (!itemsToRender && !isCopyable) return null;
      var copyMenuItems = [];
      e.persist();

      if (isCopyable) {
        //compute the cellWrapper here so we don't lose access to it
        var cellWrapper = e.target.querySelector(".tg-cell-wrapper") || e.target.closest(".tg-cell-wrapper");

        if (cellWrapper) {
          copyMenuItems.push( /*#__PURE__*/React.createElement(MenuItem, {
            key: "copyCell",
            onClick: function onClick() {
              //TODOCOPY: we need to make sure that the cell copy is being used by the row copy.. right now we have 2 different things going on
              //do we need to be able to copy hidden cells? It seems like it should just copy what's on the page..?
              var text = _this.getCellCopyText(cellWrapper);

              _this.handleCopyHelper(text, "Cell copied");
            },
            text: "Cell"
          }));
          copyMenuItems.push( /*#__PURE__*/React.createElement(MenuItem, {
            key: "copyColumn",
            onClick: function onClick() {
              _this.handleCopyColumn(e, cellWrapper);
            },
            text: "Column"
          }));
        }

        if (selectedRecords.length === 0 || selectedRecords.length === 1) {
          //compute the row here so we don't lose access to it
          var cell = e.target.querySelector(".tg-cell-wrapper") || e.target.closest(".tg-cell-wrapper") || e.target.closest(".rt-td");
          var row = cell.closest(".rt-tr");
          copyMenuItems.push( /*#__PURE__*/React.createElement(MenuItem, {
            key: "copySelectedRows",
            onClick: function onClick() {
              _this.handleCopyRow(row); // loop through each cell in the row

            },
            text: "Row"
          }));
        } else if (selectedRecords.length > 1) {
          copyMenuItems.push( /*#__PURE__*/React.createElement(MenuItem, {
            key: "copySelectedRows",
            onClick: function onClick() {
              _this.handleCopySelectedRows(selectedRecords, e); // loop through each cell in the row

            },
            text: "Rows"
          }));
        }

        copyMenuItems.push( /*#__PURE__*/React.createElement(MenuItem, {
          key: "copyFullTableRows",
          onClick: function onClick() {
            _this.handleCopyTable(e); // loop through each cell in the row

          },
          text: "Table"
        }));
      }

      var selectedRowIds = Object.keys(reduxFormSelectedCells).map(function (cellId) {
        var _cellId$split5 = cellId.split(":"),
            rowId = _cellId$split5[0];

        return rowId;
      });
      var menu = /*#__PURE__*/React.createElement(Menu, null, itemsToRender, copyMenuItems.length && /*#__PURE__*/React.createElement(MenuItem, {
        icon: "clipboard",
        key: "copyOpts",
        text: "Copy"
      }, copyMenuItems), isCellEditable && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItem, {
        icon: "add-row-top",
        text: "Add Row Above",
        key: "addRowAbove",
        onClick: function onClick() {
          _this.insertRows({
            above: true
          });
        }
      }), /*#__PURE__*/React.createElement(MenuItem, {
        icon: "add-row-top",
        text: "Add Row Below",
        key: "addRowBelow",
        onClick: function onClick() {
          _this.insertRows({});
        }
      }), /*#__PURE__*/React.createElement(MenuItem, {
        icon: "remove",
        text: "Remove Row" + (selectedRowIds.length > 1 ? "s" : ""),
        key: "removeRow",
        onClick: function onClick() {
          var _computePresets21 = computePresets(_this.props),
              _computePresets21$ent = _computePresets21.entities,
              entities = _computePresets21$ent === void 0 ? [] : _computePresets21$ent,
              reduxFormCellValidation = _computePresets21.reduxFormCellValidation,
              change = _computePresets21.change,
              _computePresets21$red = _computePresets21.reduxFormSelectedCells,
              reduxFormSelectedCells = _computePresets21$red === void 0 ? {} : _computePresets21$red;

          var selectedRowIds = Object.keys(reduxFormSelectedCells).map(function (cellId) {
            var _cellId$split6 = cellId.split(":"),
                rowId = _cellId$split6[0];

            return rowId;
          });

          _this.updateEntitiesHelper(entities, function (entities) {
            change("reduxFormCellValidation", omitBy(reduxFormCellValidation, function (v, cellId) {
              return selectedRowIds.includes(cellId.split(":")[0]);
            }));
            return entities.filter(function (e, i) {
              return !selectedRowIds.includes(getIdOrCodeOrIndex(e, i));
            });
          });

          _this.refocusTable();
        }
      })));
      ContextMenu.show(menu, {
        left: e.clientX,
        top: e.clientY
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderColumnHeader", function (column) {
      var _computePresets22 = computePresets(_this.props),
          addFilters = _computePresets22.addFilters,
          setOrder = _computePresets22.setOrder,
          order = _computePresets22.order,
          withFilter = _computePresets22.withFilter,
          withSort = _computePresets22.withSort,
          filters = _computePresets22.filters,
          removeSingleFilter = _computePresets22.removeSingleFilter,
          currentParams = _computePresets22.currentParams,
          isLocalCall = _computePresets22.isLocalCall,
          setNewParams = _computePresets22.setNewParams,
          compact = _computePresets22.compact,
          isCellEditable = _computePresets22.isCellEditable,
          extraCompact = _computePresets22.extraCompact,
          entities = _computePresets22.entities;

      var displayName = column.displayName,
          description = column.description,
          sortDisabled = column.sortDisabled,
          filterDisabled = column.filterDisabled,
          columnFilterDisabled = column.columnFilterDisabled,
          renderTitleInner = column.renderTitleInner,
          _column$filterIsActiv = column.filterIsActive,
          filterIsActive = _column$filterIsActiv === void 0 ? noop : _column$filterIsActiv,
          noTitle = column.noTitle,
          isNotEditable = column.isNotEditable,
          type = column.type,
          path = column.path;
      var columnDataType = column.type;
      var isActionColumn = columnDataType === "action";
      var disableSorting = sortDisabled || isActionColumn || !isLocalCall && typeof path === "string" && path.includes(".") || columnDataType === "color";
      var disableFiltering = filterDisabled || columnDataType === "color" || isActionColumn || columnFilterDisabled;
      var ccDisplayName = camelCase(displayName || path);
      var columnTitle = displayName || startCase(path);
      if (isActionColumn) columnTitle = "";
      var currentFilter = filters && !!filters.length && filters.filter(function (_ref13) {
        var filterOn = _ref13.filterOn;
        return filterOn === ccDisplayName;
      })[0];
      var filterActiveForColumn = !!currentFilter || filterIsActive(currentParams);
      var ordering;

      if (order && order.length) {
        order.forEach(function (order) {
          var orderField = order.replace("-", "");

          if (orderField === ccDisplayName) {
            if (orderField === order) {
              ordering = "asc";
            } else {
              ordering = "desc";
            }
          }
        });
      }

      var sortDown = ordering && ordering === "asc";
      var sortUp = ordering && !sortDown;
      var sortComponent = withSort && !disableSorting ? /*#__PURE__*/React.createElement("div", {
        className: "tg-sort-arrow-container"
      }, /*#__PURE__*/React.createElement(Icon, {
        "data-tip": "Sort Z-A (Hold shift to sort multiple columns)",
        icon: "chevron-up",
        className: classNames({
          active: sortUp
        }),
        color: sortUp ? "#106ba3" : undefined,
        iconSize: extraCompact ? 10 : 12,
        onClick: function onClick(e) {
          setOrder("-" + ccDisplayName, sortUp, e.shiftKey);
        }
      }), /*#__PURE__*/React.createElement(Icon, {
        "data-tip": "Sort A-Z (Hold shift to sort multiple columns)",
        icon: "chevron-down",
        className: classNames({
          active: sortDown
        }),
        color: sortDown ? "#106ba3" : undefined,
        iconSize: extraCompact ? 10 : 12,
        onClick: function onClick(e) {
          setOrder(ccDisplayName, sortDown, e.shiftKey);
        }
      })) : null;
      var FilterMenu = column.FilterMenu || FilterAndSortMenu;
      var filterMenu = withFilter && !disableFiltering ? /*#__PURE__*/React.createElement(ColumnFilterMenu, {
        FilterMenu: FilterMenu,
        filterActiveForColumn: filterActiveForColumn,
        addFilters: addFilters,
        removeSingleFilter: removeSingleFilter,
        currentFilter: currentFilter,
        filterOn: ccDisplayName,
        dataType: columnDataType,
        schemaForField: column,
        currentParams: currentParams,
        setNewParams: setNewParams,
        compact: compact,
        extraCompact: extraCompact
      }) : null;
      var maybeCheckbox;

      if (isCellEditable && !isNotEditable && type === "boolean") {
        var isIndeterminate = false;
        var isChecked = !!entities.length;
        var hasFalse;
        var hasTrue;
        entities.some(function (e) {
          if (!get(e, path)) {
            isChecked = false;
            hasFalse = true;
          } else {
            hasTrue = true;
          }

          if (hasFalse && hasTrue) {
            isIndeterminate = true;
            return true;
          }

          return false;
        });
        maybeCheckbox = /*#__PURE__*/React.createElement(Checkbox, {
          style: {
            marginBottom: 0,
            marginLeft: 3
          },
          onChange: function onChange() {
            _this.updateEntitiesHelper(entities, function (ents) {
              ents.forEach(function (e) {
                set(e, path, isIndeterminate ? true : !isChecked);
              });
            });
          },
          indeterminate: isIndeterminate,
          checked: isChecked
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        "data-test": displayName || startCase(path),
        "data-copy-text": displayName || startCase(path),
        className: classNames("tg-react-table-column-header", {
          "sort-active": sortUp || sortDown
        })
      }, (displayName || startCase(path)) && !noTitle && /*#__PURE__*/React.createElement(React.Fragment, null, maybeCheckbox, /*#__PURE__*/React.createElement("span", _extends({
        title: columnTitle,
        className: "tg-react-table-name"
      }, description && {
        "data-tip": "<div>\n                    <strong>" + columnTitle + ":</strong> <br>\n                    " + description + "</div>"
      }, {
        style: {
          display: "inline-block"
        }
      }), renderTitleInner ? renderTitleInner : columnTitle, " ")), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          marginLeft: "auto",
          alignItems: "center"
        }
      }, sortComponent, filterMenu));
    });

    _this.hotkeyEnabler = withHotkeys(_extends({
      moveUpARow: {
        global: false,
        combo: "up",
        label: "Move Up a Row",
        onKeyDown: _this.handleRowMove("up")
      },
      moveDownARow: {
        global: false,
        combo: "down",
        label: "Move Down a Row",
        onKeyDown: _this.handleRowMove("down")
      },
      moveUpARowShift: {
        global: false,
        combo: "up+shift",
        label: "Move Up a Row",
        onKeyDown: _this.handleRowMove("up", true)
      }
    }, _props.isCellEditable && {
      enter: {
        global: false,
        combo: "enter",
        label: "Enter -> Start Cell Edit",
        onKeyDown: _this.handleEnterStartCellEdit
      },
      cut: {
        global: false,
        combo: "mod+x",
        label: "Cut",
        onKeyDown: _this.handleCut
      },
      undo: {
        global: false,
        combo: IS_LINUX ? "alt+z" : "mod+z",
        label: "Undo",
        onKeyDown: _this.handleUndo
      },
      redo: {
        global: false,
        combo: IS_LINUX ? "alt+shift+z" : "mod+shift+z",
        label: "Redo",
        onKeyDown: _this.handleRedo
      },
      deleteCell: {
        global: false,
        combo: "backspace",
        label: "Delete Cell",
        onKeyDown: _this.handleDeleteCell
      }
    }, {
      moveDownARowShift: {
        global: false,
        combo: "down+shift",
        label: "Move Down a Row",
        onKeyDown: _this.handleRowMove("down", true)
      },
      copyHotkey: {
        global: false,
        combo: "mod + c",
        label: "Copy rows",
        onKeyDown: _this.handleCopyHotkey
      },
      selectAllRows: {
        global: false,
        combo: "mod + a",
        label: "Select rows",
        onKeyDown: _this.handleSelectAllRows
      }
    }));
    return _this;
  }

  var _proto = DataTable.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props6 = this.props,
        isCellEditable = _this$props6.isCellEditable,
        _this$props6$entities = _this$props6.entities,
        entities = _this$props6$entities === void 0 ? [] : _this$props6$entities,
        isLoading = _this$props6.isLoading,
        showForcedHiddenColumns = _this$props6.showForcedHiddenColumns,
        setShowForcedHidden = _this$props6.setShowForcedHidden;
    isCellEditable && this.formatAndValidateTableInitial();
    this.updateFromProps({}, computePresets(this.props));
    document.addEventListener("paste", this.handlePaste);

    if (!entities.length && !isLoading && !showForcedHiddenColumns) {
      setShowForcedHidden(true);
    } // const table = ReactDOM.findDOMNode(this.table);
    // let theads = table.getElementsByClassName("rt-thead");
    // let tbody = table.getElementsByClassName("rt-tbody")[0];
    // tbody.addEventListener("scroll", () => {
    //   for (let i = 0; i < theads.length; i++) {
    //     theads.item(i).scrollLeft = tbody.scrollLeft;
    //   }
    // });

  };

  _proto.componentDidUpdate = function componentDidUpdate(oldProps) {
    // const tableBody = table.querySelector(".rt-tbody");
    // const headerNode = table.querySelector(".rt-thead.-header");
    // if (headerNode) headerNode.style.overflowY = "inherit";
    // if (tableBody && tableBody.scrollHeight > tableBody.clientHeight) {
    //   if (headerNode) {
    //     headerNode.style.overflowY = "scroll";
    //     headerNode.style.overflowX = "hidden";
    //   }
    // }
    this.updateFromProps(computePresets(oldProps), computePresets(this.props)); // comment in to test what is causing re-render
    // Object.entries(this.props).forEach(
    //   ([key, val]) =>
    //     oldProps[key] !== val && console.info(`Prop '${key}' changed`)
    // );
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener("paste", this.handlePaste);
  };

  _proto.render = function render() {
    var _this2 = this;

    var fullscreen = this.state.fullscreen;
    var propPresets = computePresets(this.props);
    var extraClasses = propPresets.extraClasses,
        className = propPresets.className,
        tableName = propPresets.tableName,
        isLoading = propPresets.isLoading,
        searchTerm = propPresets.searchTerm,
        setSearchTerm = propPresets.setSearchTerm,
        clearFilters = propPresets.clearFilters,
        hidePageSizeWhenPossible = propPresets.hidePageSizeWhenPossible,
        doNotShowEmptyRows = propPresets.doNotShowEmptyRows,
        withTitle = propPresets.withTitle,
        withSearch = propPresets.withSearch,
        withPaging = propPresets.withPaging,
        isInfinite = propPresets.isInfinite,
        disabled = propPresets.disabled,
        noHeader = propPresets.noHeader,
        noFooter = propPresets.noFooter,
        noPadding = propPresets.noPadding,
        noFullscreenButton = propPresets.noFullscreenButton,
        withDisplayOptions = propPresets.withDisplayOptions,
        resized = propPresets.resized,
        resizePersist = propPresets.resizePersist,
        updateColumnVisibility = propPresets.updateColumnVisibility,
        persistPageSize = propPresets.persistPageSize,
        updateTableDisplayDensity = propPresets.updateTableDisplayDensity,
        change = propPresets.change,
        syncDisplayOptionsToDb = propPresets.syncDisplayOptionsToDb,
        resetDefaultVisibility = propPresets.resetDefaultVisibility,
        maxHeight = propPresets.maxHeight,
        style = propPresets.style,
        pageSize = propPresets.pageSize,
        formName = propPresets.formName,
        reduxFormSearchInput = propPresets.reduxFormSearchInput,
        reduxFormSelectedEntityIdMap = propPresets.reduxFormSelectedEntityIdMap,
        reduxFormExpandedEntityIdMap = propPresets.reduxFormExpandedEntityIdMap,
        schema = propPresets.schema,
        filters = propPresets.filters,
        errorParsingUrlString = propPresets.errorParsingUrlString,
        hideDisplayOptionsIcon = propPresets.hideDisplayOptionsIcon,
        compact = propPresets.compact,
        extraCompact = propPresets.extraCompact,
        compactPaging = propPresets.compactPaging,
        entityCount = propPresets.entityCount,
        showCount = propPresets.showCount,
        isSingleSelect = propPresets.isSingleSelect,
        noSelect = propPresets.noSelect,
        noRowsFoundMessage = propPresets.noRowsFoundMessage,
        SubComponent = propPresets.SubComponent,
        shouldShowSubComponent = propPresets.shouldShowSubComponent,
        _propPresets$ReactTab = propPresets.ReactTableProps,
        ReactTableProps = _propPresets$ReactTab === void 0 ? {} : _propPresets$ReactTab,
        hideSelectedCount = propPresets.hideSelectedCount,
        hideColumnHeader = propPresets.hideColumnHeader,
        subHeader = propPresets.subHeader,
        isViewable = propPresets.isViewable,
        minimalStyle = propPresets.minimalStyle,
        entities = propPresets.entities,
        onlyShowRowsWErrors = propPresets.onlyShowRowsWErrors,
        reduxFormCellValidation = propPresets.reduxFormCellValidation,
        entitiesAcrossPages = propPresets.entitiesAcrossPages,
        maybeChildren = propPresets.children,
        topLeftItems = propPresets.topLeftItems,
        leftOfSearchBarItems = propPresets.leftOfSearchBarItems,
        currentParams = propPresets.currentParams,
        hasOptionForForcedHidden = propPresets.hasOptionForForcedHidden,
        showForcedHiddenColumns = propPresets.showForcedHiddenColumns,
        searchMenuButton = propPresets.searchMenuButton,
        setShowForcedHidden = propPresets.setShowForcedHidden,
        autoFocusSearch = propPresets.autoFocusSearch,
        additionalFooterButtons = propPresets.additionalFooterButtons,
        isEntityDisabled = propPresets.isEntityDisabled,
        isLocalCall = propPresets.isLocalCall,
        withSelectAll = propPresets.withSelectAll,
        variables = propPresets.variables,
        fragment = propPresets.fragment,
        safeQuery = propPresets.safeQuery,
        isCellEditable = propPresets.isCellEditable,
        noAddMoreRowsButton = propPresets.noAddMoreRowsButton;

    if (withSelectAll && !safeQuery) {
      throw new Error("safeQuery is needed for selecting all table records");
    }

    var updateColumnVisibilityToUse = updateColumnVisibility;
    var persistPageSizeToUse = persistPageSize;
    var updateTableDisplayDensityToUse = updateTableDisplayDensity;
    var resetDefaultVisibilityToUse = resetDefaultVisibility;

    if (withDisplayOptions && !syncDisplayOptionsToDb) {
      //little hack to make localstorage changes get reflected in UI (we force an update to get the enhancers to run again :)
      var wrapUpdate = function wrapUpdate(fn) {
        return function () {
          fn.apply(void 0, arguments);
          change("localStorageForceUpdate", Math.random());
        };
      };

      updateColumnVisibilityToUse = wrapUpdate(updateColumnVisibility);
      updateTableDisplayDensityToUse = wrapUpdate(updateTableDisplayDensity);
      resetDefaultVisibilityToUse = wrapUpdate(resetDefaultVisibility);
      persistPageSizeToUse = wrapUpdate(persistPageSize);
    }

    var compactClassName = "";

    if (compactPaging) {
      compactClassName += " tg-compact-paging";
    }

    compactClassName += extraCompact ? " tg-extra-compact-table" : compact ? " tg-compact-table" : "";
    var hasFilters = filters.length || searchTerm || schema.fields.some(function (field) {
      return field.filterIsActive && field.filterIsActive(currentParams);
    });
    var additionalFilterKeys = schema.fields.reduce(function (acc, field) {
      if (field.filterKey) acc.push(field.filterKey);
      return acc;
    }, []);
    var filtersOnNonDisplayedFields = [];

    if (filters && filters.length) {
      schema.fields.forEach(function (_ref14) {
        var isHidden = _ref14.isHidden,
            displayName = _ref14.displayName,
            path = _ref14.path;
        var ccDisplayName = camelCase(displayName || path);

        if (isHidden) {
          filters.forEach(function (filter) {
            if (filter.filterOn === ccDisplayName) {
              filtersOnNonDisplayedFields.push(_extends({}, filter, {
                displayName: displayName
              }));
            }
          });
        }
      });
    }

    var numRows = isInfinite ? entities.length : pageSize;
    var idMap = reduxFormSelectedEntityIdMap || {};
    var selectedRowCount = Object.keys(idMap).filter(function (key) {
      return idMap[key];
    }).length;
    var rowsToShow = doNotShowEmptyRows ? Math.min(numRows, entities.length) : numRows; // if there are no entities then provide enough space to show
    // no rows found message

    if (entities.length === 0 && rowsToShow < 3) rowsToShow = 3;
    var expandedRows = entities.reduce(function (acc, row, index) {
      var rowId = getIdOrCodeOrIndex(row, index);
      acc[index] = reduxFormExpandedEntityIdMap[rowId];
      return acc;
    }, {});
    var children = maybeChildren;

    if (children && typeof children === "function") {
      children = children(propPresets);
    }

    var showHeader = (withTitle || withSearch || children) && !noHeader;
    var toggleFullscreenButton = /*#__PURE__*/React.createElement(Button, {
      icon: "fullscreen",
      active: fullscreen,
      minimal: true,
      onClick: this.toggleFullscreen
    });
    var showSelectAll = false;
    var showClearAll = false; // we want to show select all if every row on the current page is selected
    // and not every row across all pages are already selected.

    if (!isInfinite) {
      var canShowSelectAll = withSelectAll || entitiesAcrossPages && numRows < entitiesAcrossPages.length;

      if (canShowSelectAll) {
        // could all be disabled
        var atLeastOneRowOnCurrentPageSelected = false;
        var allRowsOnCurrentPageSelected = entities.every(function (e) {
          var rowId = getIdOrCodeOrIndex(e);
          var selected = idMap[rowId] || isEntityDisabled(e);
          if (selected) atLeastOneRowOnCurrentPageSelected = true;
          return selected;
        });

        if (atLeastOneRowOnCurrentPageSelected && allRowsOnCurrentPageSelected) {
          var everyEntitySelected;

          if (isLocalCall) {
            everyEntitySelected = entitiesAcrossPages.every(function (e) {
              var rowId = getIdOrCodeOrIndex(e);
              return idMap[rowId] || isEntityDisabled(e);
            });
          } else {
            everyEntitySelected = entityCount <= selectedRowCount;
          }

          if (everyEntitySelected) {
            showClearAll = selectedRowCount;
          } // only show if not all selected


          showSelectAll = !everyEntitySelected;
        }
      }
    }

    var showNumSelected = !noSelect && !isSingleSelect && !hideSelectedCount;
    var selectedAndTotalMessage = "";

    if (showNumSelected) {
      selectedAndTotalMessage += selectedRowCount + " Selected ";
    }

    if (showCount && showNumSelected) {
      selectedAndTotalMessage += "/ ";
    }

    if (showCount) {
      selectedAndTotalMessage += (entityCount || 0) + " Total";
    }

    if (selectedAndTotalMessage) {
      selectedAndTotalMessage = /*#__PURE__*/React.createElement("div", null, selectedAndTotalMessage);
    }

    var shouldShowPaging = !isInfinite && withPaging && (hidePageSizeWhenPossible ? entityCount > pageSize : true);
    var SubComponentToUse;

    if (SubComponent) {
      SubComponentToUse = function SubComponentToUse(row) {
        var shouldShow = true;

        if (shouldShowSubComponent) {
          shouldShow = shouldShowSubComponent(row.original);
        }

        if (shouldShow) {
          return SubComponent(row);
        }
      };
    }

    var nonDisplayedFilterComp;

    if (filtersOnNonDisplayedFields.length) {
      var content = filtersOnNonDisplayedFields.map(function (_ref15) {
        var displayName = _ref15.displayName,
            path = _ref15.path,
            selectedFilter = _ref15.selectedFilter,
            filterValue = _ref15.filterValue;
        var filterValToDisplay = filterValue;

        if (selectedFilter === "inList") {
          filterValToDisplay = Array.isArray(filterValToDisplay) ? filterValToDisplay : filterValToDisplay && filterValToDisplay.split(".");
        }

        if (Array.isArray(filterValToDisplay)) {
          filterValToDisplay = filterValToDisplay.join(", ");
        }

        return /*#__PURE__*/React.createElement("div", {
          key: displayName || startCase(path),
          className: "tg-filter-on-non-displayed-field"
        }, displayName || startCase(path), " ", lowerCase(selectedFilter), " ", filterValToDisplay);
      });
      nonDisplayedFilterComp = /*#__PURE__*/React.createElement("div", {
        style: {
          marginRight: 5,
          marginLeft: "auto"
        }
      }, /*#__PURE__*/React.createElement(Tooltip, {
        content: /*#__PURE__*/React.createElement("div", null, "Active filters on hidden columns:", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), content)
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "filter-list"
      })));
    }

    var filteredEnts = entities;

    if (onlyShowRowsWErrors) {
      var rowToErrorMap = {};
      forEach(reduxFormCellValidation, function (err, cellId) {
        if (err) {
          var _cellId$split7 = cellId.split(":"),
              rowId = _cellId$split7[0];

          rowToErrorMap[rowId] = true;
        }
      });
      filteredEnts = entities.filter(function (e) {
        return rowToErrorMap[e.id];
      });
    }

    return (
      /*#__PURE__*/
      // eslint-disable-next-line no-undef
      React.createElement(this.hotkeyEnabler, null, /*#__PURE__*/React.createElement("div", {
        className: classNames("data-table-container", extraClasses, className, compactClassName, {
          fullscreen: fullscreen,
          in_cypress_test: window.Cypress,
          //tnr: this is a hack to make cypress be able to correctly click the table without the sticky header getting in the way. remove me once https://github.com/cypress-io/cypress/issues/871 is fixed
          "dt-isViewable": isViewable,
          "dt-minimalStyle": minimalStyle,
          "no-padding": noPadding,
          "hide-column-header": hideColumnHeader
        })
      }, showHeader && /*#__PURE__*/React.createElement("div", {
        className: "data-table-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "data-table-title-and-buttons"
      }, tableName && withTitle && /*#__PURE__*/React.createElement("span", {
        className: "data-table-title"
      }, tableName), children, topLeftItems), errorParsingUrlString && /*#__PURE__*/React.createElement(Callout, {
        icon: "error",
        style: {
          width: "unset"
        },
        intent: Intent.WARNING
      }, "Error parsing URL"), nonDisplayedFilterComp, withSearch && /*#__PURE__*/React.createElement("div", {
        className: "data-table-search-and-clear-filter-container"
      }, leftOfSearchBarItems, hasFilters ? /*#__PURE__*/React.createElement(Tooltip, {
        content: "Clear Filters"
      }, /*#__PURE__*/React.createElement(Button, {
        minimal: true,
        intent: "danger",
        icon: "filter-remove",
        disabled: disabled,
        className: "data-table-clear-filters",
        onClick: function onClick() {
          clearFilters(additionalFilterKeys);
        }
      })) : "", /*#__PURE__*/React.createElement(SearchBar, {
        reduxFormSearchInput: reduxFormSearchInput,
        setSearchTerm: setSearchTerm,
        loading: isLoading,
        searchMenuButton: searchMenuButton,
        disabled: disabled,
        autoFocusSearch: autoFocusSearch
      }))), subHeader, showSelectAll && !isSingleSelect && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5,
          marginBottom: 5,
          display: "flex",
          alignItems: "center"
        }
      }, "All items on this page are selected.", " ", /*#__PURE__*/React.createElement(Button, {
        small: true,
        minimal: true,
        intent: "primary",
        text: "Select all " + (entityCount || entitiesAcrossPages.length) + " items",
        loading: this.state.selectingAll,
        onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var allEntities;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!withSelectAll) {
                    _context.next = 16;
                    break;
                  }

                  // this will be by querying for everything
                  _this2.setState({
                    selectingAll: true
                  });

                  _context.prev = 2;
                  _context.next = 5;
                  return safeQuery(fragment, {
                    variables: {
                      filter: variables.filter,
                      sort: variables.sort
                    },
                    canCancel: true
                  });

                case 5:
                  allEntities = _context.sent;

                  _this2.addEntitiesToSelection(allEntities);

                  _context.next = 13;
                  break;

                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](2);
                  console.error("error:", _context.t0);
                  window.toastr.error("Error selecting all constructs");

                case 13:
                  _this2.setState({
                    selectingAll: false
                  });

                  _context.next = 17;
                  break;

                case 16:
                  _this2.addEntitiesToSelection(entitiesAcrossPages);

                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 9]]);
        }))
      })), showClearAll > 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5,
          marginBottom: 5,
          display: "flex",
          alignItems: "center"
        }
      }, "All ", showClearAll, " items are selected.", " ", /*#__PURE__*/React.createElement(Button, {
        small: true,
        minimal: true,
        intent: "primary",
        text: "Clear Selection",
        onClick: function onClick() {
          finalizeSelection({
            idMap: {},
            entities: entities,
            props: computePresets(_this2.props)
          });
        }
      })), /*#__PURE__*/React.createElement(ReactTable, _extends({
        data: filteredEnts,
        ref: function ref(n) {
          if (n) _this2.table = n;
        },
        additionalBodyEl: isCellEditable && !noAddMoreRowsButton && /*#__PURE__*/React.createElement(Button, {
          icon: "add",
          style: {
            marginTop: "auto"
          },
          onClick: function onClick() {
            _this2.insertRows({
              numRows: 10,
              appendToBottom: true
            });
          },
          minimal: true
        }, "Add 10 Rows"),
        className: classNames({
          isCellEditable: isCellEditable,
          "tg-table-loading": isLoading,
          "tg-table-disabled": disabled
        }),
        itemSizeEstimator: extraCompact ? itemSizeEstimators.compact : compact ? itemSizeEstimators.normal : itemSizeEstimators.comfortable,
        TfootComponent: function TfootComponent() {
          return /*#__PURE__*/React.createElement("button", null, "hasdfasdf");
        },
        columns: this.renderColumns(),
        pageSize: rowsToShow,
        expanded: expandedRows,
        showPagination: false,
        sortable: false,
        loading: isLoading || disabled,
        defaultResized: resized,
        onResizedChange: function onResizedChange(newResized) {
          if (newResized === void 0) {
            newResized = [];
          }

          var resizedToUse = newResized.map(function (column) {
            // have a min width of 50 so that columns don't disappear
            if (column.value < 50) {
              return _extends({}, column, {
                value: 50
              });
            } else {
              return column;
            }
          });
          resizePersist(resizedToUse);
        },
        TheadComponent: this.getTheadComponent,
        ThComponent: this.getThComponent,
        getTrGroupProps: this.getTableRowProps,
        getTdProps: this.getTableCellProps,
        NoDataComponent: function NoDataComponent(_ref17) {
          var children = _ref17.children;
          return isLoading ? null : /*#__PURE__*/React.createElement("div", {
            className: "rt-noData"
          }, noRowsFoundMessage || children);
        },
        LoadingComponent: function LoadingComponent(props) {
          return /*#__PURE__*/React.createElement(DisabledLoadingComponent, _extends({}, props, {
            disabled: disabled
          }));
        },
        style: _extends({
          maxHeight: maxHeight,
          minHeight: 150
        }, style),
        SubComponent: SubComponentToUse
      }, ReactTableProps)), !noFooter && /*#__PURE__*/React.createElement("div", {
        className: "data-table-footer",
        style: {
          justifyContent: !showNumSelected && !showCount ? "flex-end" : "space-between"
        }
      }, selectedAndTotalMessage, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexWrap: "wrap"
        }
      }, additionalFooterButtons, !noFullscreenButton && toggleFullscreenButton, withDisplayOptions && /*#__PURE__*/React.createElement(DisplayOptions, {
        compact: compact,
        extraCompact: extraCompact,
        disabled: disabled,
        hideDisplayOptionsIcon: hideDisplayOptionsIcon,
        resetDefaultVisibility: resetDefaultVisibilityToUse,
        updateColumnVisibility: updateColumnVisibilityToUse,
        updateTableDisplayDensity: updateTableDisplayDensityToUse,
        showForcedHiddenColumns: showForcedHiddenColumns,
        setShowForcedHidden: setShowForcedHidden,
        hasOptionForForcedHidden: hasOptionForForcedHidden,
        formName: formName,
        schema: schema
      }), shouldShowPaging && /*#__PURE__*/React.createElement(PagingTool, _extends({}, propPresets, {
        persistPageSize: persistPageSizeToUse
      }))))))
    );
  };

  return DataTable;
}(React.Component); // const CompToExport =  dataTableEnhancer(HotkeysTarget(DataTable));
// // CompToExport.selectRecords = (form, value) => {
// //   return change(form, "reduxFormSelectedEntityIdMap", value)
// // }
// export default CompToExport


_defineProperty(DataTable, "defaultProps", defaultProps);

export default dataTableEnhancer(DataTable);
var ConnectedPagingTool = dataTableEnhancer(PagingTool);
export { ConnectedPagingTool };
var itemSizeEstimators = {
  compact: function compact() {
    return 25.34;
  },
  normal: function normal() {
    return 33.34;
  },
  comfortable: function comfortable() {
    return 41.34;
  }
};

function ColumnFilterMenu(_ref18) {
  var FilterMenu = _ref18.FilterMenu,
      filterActiveForColumn = _ref18.filterActiveForColumn,
      compact = _ref18.compact,
      extraCompact = _ref18.extraCompact,
      rest = _objectWithoutPropertiesLoose(_ref18, ["FilterMenu", "filterActiveForColumn", "compact", "extraCompact"]);

  var _useState = useState(false),
      columnFilterMenuOpen = _useState[0],
      setColumnFilterMenuOpen = _useState[1];

  return /*#__PURE__*/React.createElement(Popover, {
    position: "bottom",
    onClose: function onClose() {
      setColumnFilterMenuOpen(false);
    },
    isOpen: columnFilterMenuOpen,
    modifiers: {
      preventOverflow: {
        enabled: true
      },
      hide: {
        enabled: false
      },
      flip: {
        enabled: false
      }
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    style: {
      marginLeft: 5
    },
    icon: "filter",
    iconSize: extraCompact ? 14 : undefined,
    onClick: function onClick() {
      setColumnFilterMenuOpen(!columnFilterMenuOpen);
    },
    className: classNames("tg-filter-menu-button", {
      "tg-active-filter": !!filterActiveForColumn
    })
  }), /*#__PURE__*/React.createElement(FilterMenu, _extends({
    togglePopover: function togglePopover() {
      setColumnFilterMenuOpen(false);
    }
  }, rest)));
}

function getLastSelectedEntity(idMap) {
  var lastSelectedEnt;
  var latestTime;
  forEach(idMap, function (_ref19) {
    var time = _ref19.time,
        entity = _ref19.entity;

    if (!latestTime || time > latestTime) {
      lastSelectedEnt = entity;
      latestTime = time;
    }
  });
  return lastSelectedEnt;
}

function getNewEntToSelect(_ref20) {
  var type = _ref20.type,
      lastSelectedIndex = _ref20.lastSelectedIndex,
      entities = _ref20.entities,
      isEntityDisabled = _ref20.isEntityDisabled;
  var newIndexToSelect;

  if (type === "up") {
    newIndexToSelect = lastSelectedIndex - 1;
  } else {
    newIndexToSelect = lastSelectedIndex + 1;
  }

  var newEntToSelect = entities[newIndexToSelect];
  if (!newEntToSelect) return;

  if (isEntityDisabled && isEntityDisabled(newEntToSelect)) {
    return getNewEntToSelect({
      type: type,
      lastSelectedIndex: newIndexToSelect,
      entities: entities,
      isEntityDisabled: isEntityDisabled
    });
  } else {
    return newEntToSelect;
  }
}

function getAllRows(e) {
  var allRowEls = e.target.closest(".data-table-container").querySelectorAll(".rt-tr");

  if (!allRowEls || !allRowEls.length) {
    return;
  }

  return allRowEls;
}

function EditableCell(_ref21) {
  var initialValue = _ref21.initialValue,
      finishEdit = _ref21.finishEdit,
      cancelEdit = _ref21.cancelEdit,
      isNumeric = _ref21.isNumeric;

  var _useState2 = useState(initialValue),
      v = _useState2[0],
      setV = _useState2[1];

  return /*#__PURE__*/React.createElement("input", {
    style: {
      border: 0,
      width: "95%",
      fontSize: 12,
      background: "none"
    },
    type: isNumeric ? "number" : undefined,
    value: v,
    autoFocus: true,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        finishEdit(v);
        e.stopPropagation();
      } else if (e.key === "Escape") {
        cancelEdit();
      }
    },
    onBlur: function onBlur() {
      finishEdit(v);
    },
    onChange: function onChange(e) {
      setV(e.target.value);
    }
  });
}

function DropdownCell(_ref22) {
  var options = _ref22.options,
      initialValue = _ref22.initialValue,
      finishEdit = _ref22.finishEdit,
      cancelEdit = _ref22.cancelEdit;
  return /*#__PURE__*/React.createElement("div", {
    className: "tg-dropdown-cell-edit-container"
  }, /*#__PURE__*/React.createElement(TgSelect, {
    small: true // onKeyDown={e => {
    //   if (e.key === "Esc") {
    //     cancelEdit();
    //   }
    // }}
    ,
    autoOpen: true,
    value: initialValue,
    onChange: function onChange(val) {
      finishEdit(val ? val.value : null);
    },
    popoverProps: {
      onClose: cancelEdit
    },
    options: options.map(function (value) {
      return {
        label: value,
        value: value
      };
    })
  }));
}

function isTruthy(v) {
  if (!v) return false;

  if (typeof v === "string") {
    if (v.toLowerCase() === "false") {
      return false;
    }

    if (v.toLowerCase() === "no") {
      return false;
    }
  }

  return true;
} //(mutative) responsible for formatting and then validating the


export var editCellHelper = function editCellHelper(_ref23) {
  var _schema$fields3;

  var entity = _ref23.entity,
      path = _ref23.path,
      schema = _ref23.schema,
      columnSchema = _ref23.columnSchema,
      newVal = _ref23.newVal;
  var nv = newVal;
  var colSchema = columnSchema || (schema == null ? void 0 : (_schema$fields3 = schema.fields) == null ? void 0 : _schema$fields3.find(function (_ref24) {
    var p = _ref24.path;
    return p === path;
  })) || {};
  path = path || colSchema.path;
  var format = colSchema.format,
      validate = colSchema.validate,
      type = colSchema.type;
  var error;
  if (nv === undefined && colSchema.defaultValue !== undefined) nv = colSchema.defaultValue;

  if (format) {
    nv = format(nv, colSchema);
  }

  if (defaultFormatters[type]) {
    nv = defaultFormatters[type](nv, colSchema);
  }

  if (validate) {
    error = validate(nv, colSchema);
  }

  if (!error) {
    var validator = defaultValidators[type] || type === "string" || type === undefined && defaultValidators.string;

    if (validator) {
      error = validator(nv, colSchema);
    }
  }

  set(entity, path, nv);
  return {
    entity: entity,
    error: error
  };
};
var defaultFormatters = {
  "boolean": function boolean(newVal) {
    return isTruthy(newVal);
  },
  dropdown: function dropdown(newVal, field) {
    var valsMap = {};
    field.values.forEach(function (v) {
      valsMap[v.toLowerCase().trim()] = v;
    });
    return valsMap[newVal == null ? void 0 : newVal.toLowerCase().trim()] || newVal;
  },
  numeric: function numeric(newVal) {
    return toNumber(newVal);
  }
};
var defaultValidators = {
  dropdown: function dropdown(newVal, field) {
    var err = "Please choose one of the accepted values";
    if (!newVal) return err;

    if (!field.values.includes(newVal)) {
      return err;
    }
  },
  numeric: function numeric(newVal) {
    if (isNaN(newVal) || !isNumber(newVal)) {
      return "Must be a number";
    }
  },
  string: function string(newVal, field) {
    if (!field.isRequired) return false;
    if (!newVal) return "Please enter a value here";
  }
};

function getFieldPathToIndex(schema) {
  var fieldToIndex = {};
  schema.fields.forEach(function (f, i) {
    fieldToIndex[f.path] = i;
  });
  return fieldToIndex;
}

function getFieldPathToField(schema) {
  var fieldPathToField = {};
  schema.fields.forEach(function (f) {
    fieldPathToField[f.path] = f;
  });
  return fieldPathToField;
}

var defaultParsePaste = function defaultParsePaste(str) {
  return str.split(/\r\n|\n|\r/).map(function (row) {
    return row.split("\t");
  });
};

function getEntityIdToEntity(entities) {
  var entityIdToEntity = {};
  entities.forEach(function (e, i) {
    entityIdToEntity[getIdOrCodeOrIndex(e, i)] = {
      e: e,
      i: i
    };
  });
  return entityIdToEntity;
}

function endsWithNumber(str) {
  return /[0-9]+$/.test(str);
}

function getNumberStrAtEnd(str) {
  if (endsWithNumber(str)) {
    return str.match(/[0-9]+$/)[0];
  }

  return null;
}

function stripNumberAtEnd(str) {
  return str.replace(getNumberStrAtEnd(str), "");
}

var getCellVal = function getCellVal(ent, path, col) {
  var isBool = col.type === "boolean";
  var selectedCellVal = get(ent, path, "");

  if (isBool) {
    selectedCellVal = selectedCellVal === "True";
    selectedCellVal = isTruthy(selectedCellVal);
  }

  return selectedCellVal;
};